window.RECO_COLOR_MAP = {
  "AZALEA": "#d96080",
  "Adjustable Black": "#111111",
  "Adjustable Charcoal": "#5c5c5c",
  "Adjustable Grey": "#9e9e9e",
  "Adjustable Navy": "#003366",
  "Adjustable Royal": "#2952a3",
  "Adjustable White": "#ffffff",
  "Admiral Duck Camo/ Black": "#4a5240",
  "Aloe": "#8fa67a",
  "Alpine Green": "#4a7c59",
  "Alt White": "#f5f5f5",
  "Alt White/ Black": "#f5f5f5",
  "Alt White/ Navy": "#f5f5f5",
  "Amber Gold": "#c9941a",
  "Amber Gold/ Navy": "#c9941a",
  "Anchor Slate": "#6b7280",
  "AnchorGrey": "#6b7280",
  "Anthracite": "#464b4f",
  "Antique Brass": "#c9941a",
  "Antique Cherry Red": "#8b1a2a",
  "Antique Denim": "#5b7fa6",
  "Antique Gold": "#c9941a",
  "Antique Heliconia": "#c85070",
  "Antique Sapphire": "#1a4a7a",
  "AntqGold": "#b09020",
  "Antqu Chry Red": "#8b1a2a",
  "Antqu Helicon": "#c85070",
  "Antqu Sapphire": "#1a4a7a",
  "Apricot": "#f5a57a",
  "Aqua": "#00bcd4",
  "Aqua Blue/ White": "#00bcd4",
  "Aqua TB": "#00bcd4",
  "AquaBlue": "#00bcd4",
  "AquaHthr": "#6ecfd4",
  "AquaTB": "#00bcd4",
  "Aquamarine": "#4dd0c4",
  "Aquatic Blue": "#1a8fa0",
  "AquaticBl": "#1a8fa0",
  "Army": "#4b5320",
  "Army Camo": "#4b5320",
  "Army Camo/ Black": "#4b5320",
  "Army Camo/ White": "#4b5320",
  "Army Green": "#4b5320",
  "Army Heather": "#6b7355",
  "Army Loden": "#4b5320",
  "Army Olive": "#5a5e3a",
  "Army Olive Green/ Tan": "#5a5e3a",
  "Army/ Black": "#4b5320",
  "Army/ Gold": "#4b5320",
  "Army/ Khaki": "#4b5320",
  "Army/ Orange": "#4b5320",
  "Army/ White": "#4b5320",
  "Artisan Gold": "#c9941a",
  "Aruba Blue/ Birch": "#1e7db5",
  "Ash": "#c8c8c0",
  "Ash Grey": "#b2b2b2",
  "Ash Heather": "#c8c8c0",
  "AshGrey": "#b2b2b2",
  "Asphalt": "#3a3a3a",
  "AsphaltGry": "#3a3a3a",
  "Ath Heather": "#b5b5b5",
  "Ath Maroon": "#7b1c2a",
  "Ath. Maroon": "#6b0020",
  "AthKlly": "#006b2b",
  "Athl Grey TB": "#b5b5b5",
  "AthlHthr": "#b5b5b5",
  "AthlMaroon": "#6b0020",
  "Athletic Heather": "#b5b5b5",
  "Athletic Ht": "#b5b5b5",
  "Athletic Hthr": "#9e9e9e",
  "Athletic Red": "#bf1b23",
  "Atlantic": "#1a4a7a",
  "Atomic Blue": "#1565c0",
  "Autumn": "#a0522d",
  "AwrnsPink": "#e91e8c",
  "AwrnsPnkHt": "#e96baa",
  "Azalea": "#d96080",
  "Baby Blue": "#89cff0",
  "Baby Pink": "#f4a7b9",
  "BabyBlue": "#90caf9",
  "BakedClay": "#b05a2f",
  "Banana": "#f5e642",
  "BananaCrm": "#fdf6b2",
  "Bark": "#6b4c2a",
  "Bark Duck Camo/ Brown": "#6b4c2a",
  "Batlshp Grey": "#708090",
  "Battleship Grey": "#708090",
  "Battleship Gry": "#708090",
  "Bay": "#4682b4",
  "Bay/ White": "#4682b4",
  "Beetle/ Quarry": "#5a5a3c",
  "Berry": "#6a1a4a",
  "Berry TB": "#6a1a4a",
  "BerryTB": "#8b0057",
  "Birch": "#d4c9a8",
  "Birch/ Black": "#d4c9a8",
  "Birch/ Brown/ Loden": "#d4c9a8",
  "Biscuit/ Black": "#e8dcc8",
  "Biscuit/ True Blue": "#e8dcc8",
  "Black": "#1c1c1c",
  "Black Camo": "#2a2a2a",
  "Black Char Hth": "#2d2d2d",
  "Black Frost": "#3a3a3a",
  "Black Heather": "#3a3a3a",
  "Black Heather/ Black": "#2d2d2d",
  "Black Ht": "#3a3a3a",
  "Black Ht TB": "#3a3a3a",
  "Black/ Alt White": "#111111",
  "Black/ Birch": "#111111",
  "Black/ Black": "#111111",
  "Black/ Black-Grey": "#111111",
  "Black/ Camo": "#111111",
  "Black/ Camo/ Loden": "#111111",
  "Black/ Charcoal": "#111111",
  "Black/ Charcoal Split": "#111111",
  "Black/ Charcoal/ White": "#111111",
  "Black/ Forest": "#111111",
  "Black/ Forest/ Black": "#111111",
  "Black/ Gold": "#111111",
  "Black/ Gold/ White": "#111111",
  "Black/ Graphite": "#111111",
  "Black/ Grey/ White": "#111111",
  "Black/ Kelly": "#111111",
  "Black/ Khaki": "#111111",
  "Black/ Light Grey CMB": "#111111",
  "Black/ Maroon": "#111111",
  "Black/ Navy/ White": "#111111",
  "Black/ Neon Green": "#111111",
  "Black/ Neon Orange": "#111111",
  "Black/ Neon Pink": "#111111",
  "Black/ Orange": "#111111",
  "Black/ Purple": "#111111",
  "Black/ Purple/ White": "#111111",
  "Black/ Red": "#111111",
  "Black/ Red/ White": "#111111",
  "Black/ Royal/ White": "#111111",
  "Black/ Scarlet": "#111111",
  "Black/ Silver": "#111111",
  "Black/ Stone Stitch": "#111111",
  "Black/ Teal": "#111111",
  "Black/ Vegas Gold": "#111111",
  "Black/ Vegas Gold/ White": "#111111",
  "Black/ White": "#111111",
  "Black/ White Split": "#111111",
  "Black/ White/ Black": "#111111",
  "Black/ White/ Heather Grey": "#111111",
  "Black/ White/ Red": "#111111",
  "Black/Bat Grey": "#111111",
  "Black/Batl Gry": "#111111",
  "Black/Grey": "#111111",
  "Black/Imp Blue": "#111111",
  "Black/White": "#1c1c1c",
  "BlackCamo": "#2a2e1e",
  "BlackHtTB": "#2d2d2d",
  "Blacktop": "#1a1a1a",
  "Blaze Duck Camo/ Blaze": "#ff6600",
  "Blaze Orange": "#ff6600",
  "Blizzard Duck Camo/ White": "#e8e8e8",
  "Blk/Red": "#111111",
  "Blk/Shock Blue": "#111111",
  "Blk/Shock Grn": "#1c1c1c",
  "Blk/Silver": "#111111",
  "BlkHtTB": "#2d2d2d",
  "BlkHthr": "#3a3a3a",
  "Blossom": "#f4a7b9",
  "BluStormTb": "#4a6a8a",
  "Blue Aqua": "#0090a0",
  "Blue Heather": "#6699cc",
  "Blue Jean": "#5b7fa6",
  "Blue Lake": "#4a7fb5",
  "Blue Magic": "#1565c0",
  "Blue Spruce": "#2e7d6c",
  "Blue Storm": "#1a3a5c",
  "Blue TB": "#2e5ead",
  "Blue Teal/ Birch/ Navy": "#008080",
  "BlueFog": "#8aaac7",
  "BlueIce": "#a8d8e8",
  "BlueJean": "#5b7fa6",
  "BlueSoul": "#1a4fa0",
  "BlueSpruce": "#2e7d6c",
  "BlueStorm": "#4a6a8a",
  "BlueTint": "#ddeeff",
  "Bluestone": "#4a6a8a",
  "Blush Frost": "#f5d0d8",
  "Blush Pink": "#f4a7b9",
  "Blush/Rose": "#f4a7b9",
  "BlustFrost": "#c8d8e8",
  "Bold Gold": "#c9941a",
  "Bold Orange": "#e65100",
  "Bold Pink": "#e91e8c",
  "Bolt Blue": "#0047ab",
  "Bone": "#e8dcc8",
  "BottleGrn": "#006a4e",
  "Boysenberry": "#6b2d5e",
  "Brick": "#8a2a1a",
  "Brick TB": "#8a2a1a",
  "Bright Aqua": "#00e5ff",
  "Bright Lime": "#bfff00",
  "Bright Navy": "#001f5b",
  "Bright Orange": "#f5620f",
  "Bright Salmon": "#ff6b6b",
  "Bright White": "#ffffff",
  "BrightAqua": "#00d4e0",
  "BrightRoyal": "#1a52c7",
  "BrillOrng": "#ff6600",
  "BriteLime": "#bfff00",
  "BriteOrng": "#ff5f00",
  "Bronze": "#8c6b2f",
  "Brown": "#5d4037",
  "Brown Savana Camo": "#6b4c2a",
  "Brown Sugar": "#8c5a2f",
  "Brown TB": "#5d4037",
  "Brown/ Desert Camo": "#6b4c2a",
  "Brown/ Khaki": "#6b4c2a",
  "Brown/ Khaki CMB": "#6b4c2a",
  "Brown/ Khaki/ Khaki": "#6b4c2a",
  "Brown/ Sand": "#6b4c2a",
  "Brown/ White": "#6b4c2a",
  "Brown/ White/ Brown": "#6b4c2a",
  "BrownTweed": "#7a5c3a",
  "Brt Kelly Grn": "#009a44",
  "Brt Lavender": "#b57bee",
  "BrtBlue": "#1565c0",
  "BrtOrng": "#ff6600",
  "BrtSalmon": "#ff6b6b",
  "BrtWhite": "#ffffff",
  "BubblePink": "#f4a7b9",
  "Buff": "#e8d5a0",
  "Burgundy": "#800020",
  "Burgundy Hthr": "#7a1a2e",
  "Burnt Orange": "#8a3a0a",
  "BurntOrange": "#bf5700",
  "BurntOrng": "#bf5700",
  "Butter": "#f5e642",
  "CAROLINA BLUE": "#6daedb",
  "Cactus": "#5a7a3a",
  "Cadet Blue": "#5f9ea0",
  "Camel": "#c19a6b",
  "Camo/ Black": "#4b5320",
  "Camouflage": "#4b5320",
  "Candy Pink": "#f4a7b9",
  "CandyPink": "#f4a7b9",
  "Canvas Red": "#c0392b",
  "CanvasRed": "#cc3333",
  "Canyon": "#c67c48",
  "CanyonPink": "#e8a080",
  "Caramel": "#b87040",
  "Caramel/ Black": "#c19a6b",
  "Carbon": "#333333",
  "Carbon Heather": "#5a5a5a",
  "Cardinal": "#8b1a2a",
  "Cardinal Red": "#8b0000",
  "Cardinal TB": "#8b1a2a",
  "Cardinal/ Black": "#8b0000",
  "Cardinal/ Black/ White": "#8b0000",
  "Cardinal/ Gold": "#8b0000",
  "Cardinal/ Gold/ White": "#8b0000",
  "Cardinal/ Navy": "#8b0000",
  "Cardinal/ White": "#8b0000",
  "Cardinal/ White/ Cardinal": "#8b0000",
  "Cargo Khaki": "#b5a26b",
  "Cargo Khaki/ Black": "#b5a26b",
  "Carhartt Brown": "#6b4c3b",
  "CarharttBr": "#6b4c3b",
  "CariBluHtr": "#5a9fc0",
  "CariBlue": "#1a8fa0",
  "Carmel/ Birch": "#c19a6b",
  "Carmel/ Black": "#c19a6b",
  "Carolina Blue": "#6daedb",
  "Carolina Blue/ Navy": "#4b9cd3",
  "Carolina Blue/ White/ Caroline Blue": "#4b9cd3",
  "CarolinaBl": "#6daedb",
  "Cashmere": "#e8d5b0",
  "Cayenne": "#c0303a",
  "Cedar": "#8b3a2f",
  "Celadon": "#ace1af",
  "Cement": "#8a8a7a",
  "CementTb": "#8a8a7a",
  "Cerise": "#de3163",
  "Chalky Mint": "#c8f0d8",
  "ChalkyMint": "#c8f0d8",
  "Chambray": "#6b8fa8",
  "Char Heather": "#5c5c5c",
  "Char Hthr Grey": "#5c5c5c",
  "Char-Blk TB": "#555555",
  "Char/Black": "#5c5c5c",
  "CharBlack": "#2a2a2a",
  "CharGrey": "#5c5c5c",
  "Charcoal": "#555555",
  "Charcoal Grey Heather": "#5c5c5c",
  "Charcoal Heather": "#555555",
  "Charcoal Heather/ Black": "#555555",
  "Charcoal Hthr": "#5c5c5c",
  "Charcoal.": "#5c5c5c",
  "Charcoal/ Black": "#5c5c5c",
  "Charcoal/ Black Split": "#5c5c5c",
  "Charcoal/ Black/ Gold": "#5c5c5c",
  "Charcoal/ Black/ White": "#5c5c5c",
  "Charcoal/ Burnt Orange/ Black": "#5c5c5c",
  "Charcoal/ Columbia Blue": "#5c5c5c",
  "Charcoal/ Cyan": "#5c5c5c",
  "Charcoal/ Ice Grey": "#5c5c5c",
  "Charcoal/ Kelly": "#5c5c5c",
  "Charcoal/ Navy": "#5c5c5c",
  "Charcoal/ Navy/ White": "#5c5c5c",
  "Charcoal/ Neon Blue": "#5c5c5c",
  "Charcoal/ Neon Green": "#5c5c5c",
  "Charcoal/ Neon Orange": "#5c5c5c",
  "Charcoal/ Neon Pink": "#5c5c5c",
  "Charcoal/ Neon Yellow": "#5c5c5c",
  "Charcoal/ Old Gold": "#5c5c5c",
  "Charcoal/ Orange": "#5c5c5c",
  "Charcoal/ Red": "#5c5c5c",
  "Charcoal/ Royal": "#5c5c5c",
  "Charcoal/ Royal/ White": "#5c5c5c",
  "Charcoal/ White": "#5c5c5c",
  "Charcoal/ White Split": "#5c5c5c",
  "Charcoal/ White/ Black": "#5c5c5c",
  "Charity Pink": "#f07898",
  "CharityPTb": "#f07898",
  "CharityPnk": "#f07898",
  "Cherry Red": "#9b1b30",
  "Cherry Tomato": "#cc3333",
  "CherryRed": "#9b1b30",
  "Chestnut": "#7b3d2a",
  "Chic Lime": "#c8f060",
  "Chili": "#c0303a",
  "Chili Red/Blk": "#c0303a",
  "Chill": "#7ec8e3",
  "China Blue": "#315f8c",
  "ChinaBlue": "#315f8c",
  "Chive": "#6b7c2a",
  "Chocolate Chip/ Birch": "#3b1f0a",
  "Chocolate Chip/ Grey Brown": "#3b1f0a",
  "Chrome Yellow": "#f5c800",
  "ChryBlsm": "#f4a7b9",
  "Cinnamon Red/ Olive Green/ Stone": "#b05a2f",
  "Citron": "#9fa91f",
  "Citrus": "#f5a500",
  "Classic Navy": "#1a2848",
  "Classic Navy Heather": "#3a4a6b",
  "Classic Red": "#cc0000",
  "ClassicRed": "#cc0000",
  "Clay": "#b07050",
  "Clay Red": "#b05a2f",
  "Clay TB": "#b07050",
  "Clay/ White-Black": "#b05a2f",
  "ClayGreen": "#7a8a5a",
  "Cloud Blue": "#c0d8e8",
  "Clover Green": "#3a7a3a",
  "CloverGrn": "#3a7a3a",
  "ClscOrange": "#e65100",
  "Coal Heather": "#4a4a4a",
  "CoalGrey": "#4a4a4a",
  "Coastal Blue": "#1a6b8a",
  "Cobalt": "#1a52c7",
  "Cobalt Blue/ Grey": "#1a52c7",
  "Cobalt Blue/ White": "#1a52c7",
  "Cocoa": "#4a2c2a",
  "Coffee": "#4a3728",
  "Coffee Bean": "#3c1f0a",
  "Collegiate Blue": "#1a3a6b",
  "Colonial Blue": "#4682b4",
  "Colonial Blue/ Black": "#4682b4",
  "Colonial Blue/ White": "#4682b4",
  "Columbia Blue": "#6daedb",
  "Columbia Blue/ Black": "#4b9cd3",
  "Columbia Blue/ Khaki": "#4b9cd3",
  "Columbia Blue/ Navy": "#4b9cd3",
  "Columbia Blue/ Navy/ White": "#4b9cd3",
  "Columbia Blue/ White": "#4b9cd3",
  "Columbia Blue/ White/ Navy": "#4b9cd3",
  "ColumbiaBl": "#6daedb",
  "Comfort Wash Flo Blue": "#5b8db8",
  "Concrete Grey": "#808080",
  "CooBlue": "#4a7aa0",
  "Cool Blue": "#6699cc",
  "Cool Gray": "#9e9ea0",
  "Cool Grey": "#9faab5",
  "CoolGrey": "#9faab5",
  "CoolHtrGry": "#9faab5",
  "Copper": "#b87333",
  "Coral": "#ff6b6b",
  "Coral Craze": "#ff6b6b",
  "Coral Silk": "#f08080",
  "Coral Splash": "#ff8c69",
  "CoralSilk": "#f08878",
  "Cordovan": "#6b2d2d",
  "Corn Silk": "#f8d565",
  "Cornsilk": "#f8d565",
  "Cotton Candy": "#ffb7d5",
  "CottonPink": "#ffb7d5",
  "CourtPrpl": "#5a2d82",
  "Coyote Brown": "#81613c",
  "Coyote Brown/ Black": "#81613c",
  "CoyoteBrn": "#81613c",
  "CoyteBrnHr": "#81613c",
  "Cranberry": "#9b1b30",
  "Cream": "#fdf6e3",
  "Cream/ Black": "#fffdd0",
  "Cream/ Black/ Loden Green": "#fffdd0",
  "Cream/ Caramel": "#fffdd0",
  "Cream/ Dark Green": "#fffdd0",
  "Cream/ Forest": "#fffdd0",
  "Cream/ Grey Brown/ Brown": "#fffdd0",
  "Cream/ Light Denim": "#fffdd0",
  "Cream/ Loden Green/ Dark Orange": "#fffdd0",
  "Cream/ Maroon": "#fffdd0",
  "Cream/ Navy": "#fffdd0",
  "Cream/ Navy/ Amber Gold": "#fffdd0",
  "Cream/ Red": "#fffdd0",
  "Cream/ Stone": "#fffdd0",
  "Cream/ Wheat": "#fffdd0",
  "CreamHthr": "#e8dcc8",
  "Creamsicle Pink/ White": "#ffb7d5",
  "Creme": "#fffdd0",
  "Crimson": "#dc143c",
  "Crimson Fall": "#dc143c",
  "Crimson/ White": "#dc143c",
  "CrimsonGold": "#dc143c",
  "CrimsonHthr": "#dc143c",
  "CrnationPk": "#f4a7b9",
  "Crunchberry": "#c71585",
  "Crunchbrry": "#c71585",
  "Crush Orange": "#e65100",
  "Cumin": "#8b4513",
  "Curry": "#c8891a",
  "Cyan/ Black": "#00bcd4",
  "Cyan/ White": "#00bcd4",
  "Cypress": "#3d5a3e",
  "Cypress Green": "#3d5a3e",
  "DB Nvy/Bat Gry": "#001a33",
  "DKChocolte": "#3a1a0a",
  "DTG Black": "#1c1c1c",
  "DTG White": "#f5f5f5",
  "DTGBlack": "#1c1c1c",
  "Daffodil": "#ffff31",
  "Dafodil Yellow": "#ffff31",
  "Daisy": "#f8c030",
  "Dark Charcoal": "#3a3a3a",
  "Dark Chocolate": "#3a1a0a",
  "Dark Chocolate/ Birch": "#3b1f0a",
  "Dark Fuchsia": "#cc0066",
  "Dark Green": "#1a3d20",
  "Dark Green/ Black": "#1a4a1a",
  "Dark Green/ Gold": "#1a4a1a",
  "Dark Green/ Gold/ White": "#1a4a1a",
  "Dark Green/ White": "#1a4a1a",
  "Dark Grey": "#4a4a4a",
  "Dark Grey Heather": "#4a4a4a",
  "Dark Grey Ht": "#4a4a4a",
  "Dark Grey/ Black": "#4a4a4a",
  "Dark Grey/ Columbia Blue": "#4a4a4a",
  "Dark Grey/ Navy": "#4a4a4a",
  "Dark Grey/ Red": "#4a4a4a",
  "Dark Grey/ Royal": "#4a4a4a",
  "Dark Grey/ White": "#4a4a4a",
  "Dark Heather": "#555555",
  "Dark Heather Grey": "#4a4a4a",
  "Dark Heather/ Black": "#4a4a4a",
  "Dark Heather/ Red": "#4a4a4a",
  "Dark Khaki": "#a09060",
  "Dark Loden/ Jaffa Orange": "#4b5320",
  "Dark Loden/ Tannin-Grey": "#4b5320",
  "Dark Maroon": "#6b0020",
  "Dark Mocha/ Khaki": "#6f4e37",
  "Dark Navy": "#0a1020",
  "Dark Olive": "#4a4a1a",
  "Dark Olive Green/ White": "#4a4a2a",
  "Dark Orange/ Birch/ Patriot Blue": "#e65100",
  "Dark Orange/ Black": "#e65100",
  "Dark Oxford": "#4a4a4a",
  "Dark Red": "#8b0000",
  "Dark Teal": "#006b5a",
  "DarkBlue": "#1a2e78",
  "DarkGreen": "#1a3d20",
  "DarkGrey": "#4a4a4a",
  "DarkHeather": "#4a4a4a",
  "DarkHthr": "#555555",
  "DarkMocha": "#6f4e37",
  "DarkNavy": "#0a1020",
  "DarkRoyal": "#1a2a8b",
  "Darkwood Tree Camo": "#3a3020",
  "Davy Grey": "#555555",
  "Deadwood Tree Camo": "#4a3a20",
  "Deep Berry": "#6b0040",
  "Deep Black": "#0a0a0a",
  "Deep Blue/ Charcoal": "#1a3a6b",
  "Deep Brown Hth": "#5a3a2a",
  "Deep Forest": "#1a3a1a",
  "Deep Forest Gn": "#1a3a1a",
  "Deep Forte Blue": "#1a3a6b",
  "Deep Heather": "#3a3a3a",
  "Deep Ht": "#3a3a3a",
  "Deep Marine": "#1a4a6b",
  "Deep Navy": "#001a33",
  "Deep Orange": "#e65100",
  "Deep Pacific": "#1a3a6b",
  "Deep Purple": "#5a1a7a",
  "Deep Red": "#8b0000",
  "Deep Royal": "#1a2e78",
  "Deep Royal/ White": "#1a2a8b",
  "Deep Smoke": "#4a4a4a",
  "Deep Teal": "#006060",
  "DeepBlack": "#0a0a0a",
  "DeepGreyHt": "#4a4a4a",
  "DeepOrange": "#e65100",
  "DeepRed": "#8b0000",
  "DeepRoyal": "#1a2a8b",
  "DeepSmoke": "#4a4a4a",
  "DeepStlBlu": "#4682b4",
  "DeepestGry": "#3a3a3a",
  "Denim": "#5b7fa6",
  "Denim TB": "#5b7fa6",
  "Desert": "#c8a96e",
  "Desert Camo": "#c2b280",
  "Desert Camo/ Brown": "#c2b280",
  "Desert Khaki": "#c2b280",
  "Desert Pink": "#e8a080",
  "Desert Tan": "#c2b280",
  "DesertDust": "#c2b280",
  "DesertKhk": "#c8a96e",
  "DesertPink": "#d4a0a0",
  "DesertRose": "#dcb0b0",
  "DesertTan": "#c2b280",
  "Diesel Grey": "#6b6b6b",
  "Digital Camo/ Black": "#5a6040",
  "Digital Camo/ Light Green": "#5a6040",
  "Digital Navy": "#1a2a4a",
  "Digital Purple": "#5a1a7a",
  "Dill Green": "#6b8a3a",
  "Dk Brn/Sandstn": "#6b4c3b",
  "Dk Char/Black": "#2a2a2a",
  "Dk Choc Brown": "#3b1f0a",
  "Dk Choc. Brown": "#3b1f0a",
  "Dk Chocolate": "#3b1f0a",
  "Dk Forest": "#1a3a1a",
  "Dk Green/ Gold": "#1a4a1a",
  "Dk Heather": "#4a4a4a",
  "Dk Hthr Grey": "#4a4a4a",
  "Dk Navy": "#001a33",
  "DkBrown": "#3b1f0a",
  "DkBrwnHthr": "#5a3a2a",
  "DkCharcoal": "#2a2a2a",
  "DkChoc": "#3a1a0a",
  "DkChoc/Brn": "#3b1f0a",
  "DkChocBrn": "#3b1f0a",
  "DkForest": "#1a3a1a",
  "DkFuchsia": "#cc0066",
  "DkGold": "#b8860b",
  "DkGreen": "#1a4a1a",
  "DkGyHthr": "#555555",
  "DkHtGry": "#4a4a4a",
  "DkLavender": "#7a5a9a",
  "DkLvndrTb": "#7a5a9a",
  "DkMaroon": "#6b0020",
  "DkNavy": "#001a33",
  "DkRed": "#8b0000",
  "Dp Royal Fleck": "#1a2a8b",
  "Dp Turqu Fleck": "#40e0d0",
  "DpHeather": "#3a3a3a",
  "DpOrHthr": "#e65100",
  "Dress Blue Nvy": "#1a2040",
  "Driftwood": "#b5a07a",
  "Driftwood/ Khaki": "#b5a07a",
  "Driftwood/ Natural": "#b5a07a",
  "Drk Hthr Grey": "#4a4a4a",
  "DrkHthrGry": "#5c5c5c",
  "DsrtTanHtr": "#c2b280",
  "DstyBlu TB": "#7a8aa0",
  "Duck Blue": "#1a6b8a",
  "Duck Brown": "#6b4c3b",
  "Duck Camo": "#6b6b2a",
  "DuckBrown": "#6b4c2a",
  "Dune": "#c2b280",
  "Dusk": "#6b7a8a",
  "Dust": "#b0a090",
  "Dusty Blue": "#7a9fc0",
  "Dusty Blue/ White": "#7a9fc0",
  "Dusty Brown": "#8c6b4a",
  "Dusty Grape": "#8b6b8b",
  "Dusty Peach": "#f5c0a0",
  "Dusty Pink": "#d4a0b0",
  "Dusty Purple": "#8b6b8b",
  "Dusty Red/ White": "#c0303a",
  "Dusty Rose": "#dcb0b0",
  "Dusty Sage": "#8a9a7a",
  "DustyBlue": "#7a8aa0",
  "DustyPeach": "#f5c0a0",
  "DustyPurple": "#8b6b8b",
  "DustyRose": "#dcb0b0",
  "Earth": "#8b6914",
  "EchoSteel": "#708090",
  "EcoHeather": "#9e9e9e",
  "Ecru": "#c8b89a",
  "Ecru/ Navy": "#c8b89a",
  "Eggplant": "#380835",
  "ElecBlue": "#1a90ff",
  "ElecPrplHt": "#7f00ff",
  "ElecPurple": "#7f00ff",
  "Electric Blue": "#0066ff",
  "Electric Green": "#30d020",
  "Electric Orange": "#ff5500",
  "Electric Yellow": "#ffff00",
  "Emerald": "#006b3c",
  "Emerald TB": "#2e8b57",
  "EmeraldGreen": "#006b3c",
  "Empire Blue": "#1a3a8b",
  "Empire Yellow": "#f5c800",
  "Envy": "#4caf50",
  "Envy Sleeves/ Heather White Body": "#4caf50",
  "Envy Sleeves/ Premium Heather Body": "#4caf50",
  "Enzyme Blue": "#5b7fa6",
  "Espresso": "#3c1f0a",
  "EspressoBean": "#3c1f0a",
  "EuclptusBl": "#a8c8b8",
  "Event Teal": "#008080",
  "Evergreen": "#1a4a2a",
  "Evergreen/ White": "#1a5a1a",
  "FOREST": "#2d5a1b",
  "Faded Fatigue": "#5a6040",
  "FadedDenim": "#5b7fa6",
  "Fan Candy Pink": "#f4a7b9",
  "Fan Dark Green": "#1a4a1a",
  "Fan Dark Purple": "#5a1a7a",
  "Fan Deep Royal": "#1a2a8b",
  "Fan Marine Green": "#1a5a3a",
  "Fan Texas Orange": "#bf5700",
  "FanCandyPk": "#f07898",
  "FanDeepRoy": "#1a2e78",
  "FanDkGreen": "#1a3d20",
  "FanDkPrpl": "#4a2472",
  "FanMrnGrn": "#2d5a1b",
  "FanTOrange": "#e8531a",
  "FandangoPnk": "#de5285",
  "Fatigue": "#5a6040",
  "Fern": "#4a7a4a",
  "Field Green": "#4a6a3a",
  "Field Khaki": "#b5a26b",
  "Fiery Red": "#cc0000",
  "FieryRed": "#cc0000",
  "Fiesta": "#cc3333",
  "FireRed": "#cc0000",
  "FlagBlack": "#1c1c1c",
  "FlagCamo": "#4b5320",
  "FlagDpNavy": "#001a33",
  "FlagGrph": "#4a4a4a",
  "FlagRoyal": "#2952a3",
  "FlagScarRd": "#ff2400",
  "FlagWhite": "#ffffff",
  "Flame": "#e25822",
  "Flamingo": "#f08080",
  "Flint Grey": "#6b6b6b",
  "Flint Stone": "#8a8a8a",
  "Flint/ Black": "#6b6b6b",
  "FlintGrey": "#6b6b6b",
  "FlntBluHtr": "#6b7a8a",
  "Flo Blue": "#5b8db8",
  "FloBlue": "#5b8db8",
  "FlushPink": "#ff69b4",
  "Fog": "#c8d0d8",
  "FogBlue": "#8aaac7",
  "ForceBlHtr": "#1a52c7",
  "Forest": "#2d5a1b",
  "Forest Camo": "#2d5a1b",
  "Forest Green": "#2d5a1b",
  "Forest Green/ Black": "#2e6b2e",
  "Forest Green/ White": "#2e6b2e",
  "Forest/ Black": "#2e6b2e",
  "Forest/ Black/ White": "#2e6b2e",
  "Forest/ Gold": "#2e6b2e",
  "Forest/ Gold/ Black": "#2e6b2e",
  "Forest/ Khaki": "#2e6b2e",
  "Forest/ Orange": "#2e6b2e",
  "Forest/ Orange/ Black": "#2e6b2e",
  "Forest/ White": "#2e6b2e",
  "ForestGnHt": "#5a7a5a",
  "ForestGrn": "#2d5a1b",
  "FrenchNavy": "#002366",
  "FreshPeach": "#f5c0a0",
  "FreshWtrBl": "#5a9ab0",
  "Freshwater": "#1a8fa0",
  "Frontier Blue": "#1a3a6b",
  "Frost": "#e8f4f8",
  "FrstGrn": "#2e6b2e",
  "FschFrost": "#cc0066",
  "Fuchsia": "#d4007a",
  "Fuchsia Frost": "#cc0066",
  "Fuchsia Pink": "#cc0066",
  "FuchsiaPnk": "#cc0066",
  "Future Lavender": "#c8a2c8",
  "Galapagos Blue": "#1a6b8a",
  "Gallant Gold": "#c9941a",
  "GameRoyal": "#2040b0",
  "Gardenia": "#f8f4e3",
  "Garnet": "#7b1c2a",
  "Glacier": "#c8e8f0",
  "GlazedGrn": "#5a8a3a",
  "Gold": "#c9a227",
  "Gold Fusion": "#c9941a",
  "Gold/ Black": "#c9941a",
  "Gold/ Black/ Gold": "#c9941a",
  "Gold/ Black/ White": "#c9941a",
  "Gold/ Forest": "#c9941a",
  "Gold/ Navy": "#c9941a",
  "Gold/ Red": "#c9941a",
  "Gold/ Royal": "#c9941a",
  "Gold/ White": "#c9941a",
  "Gold/ White/ Black": "#c9941a",
  "Gold/Forest": "#c9941a",
  "GoldFusion": "#c9941a",
  "GoldHthr": "#c9941a",
  "GoldKhaki": "#c9941a",
  "GoldRush": "#c9941a",
  "Golden Yellow": "#f5c800",
  "GorgeGreen": "#1a5a1a",
  "GphHeather": "#6a6a6a",
  "Granite": "#6b6b6b",
  "Grape": "#6b2d8b",
  "Grape Heather": "#7a3a8b",
  "Grape Soda": "#6b2d8b",
  "Graphite": "#6a6a6a",
  "Graphite Grey": "#4a4a4a",
  "Graphite Heather": "#6a6a6a",
  "Graphite Hthr": "#6a6a6a",
  "Graphite/ Black": "#4a4a4a",
  "Graphite/ Black/ White": "#4a4a4a",
  "Graphite/ White": "#4a4a4a",
  "Grass": "#5a8a1a",
  "Grass Grn TB": "#5a9a3a",
  "GrassGreen": "#5a8a1a",
  "Gravel": "#8a8a8a",
  "Gravel Grey": "#8a8a8a",
  "Green Apple": "#4caf50",
  "Green Bay": "#1a5a1a",
  "Green Camo": "#4b5320",
  "Green Camo/ Black": "#4b5320",
  "Green Camo/ Stars & Stripes": "#4b5320",
  "Green Camo/ White": "#4b5320",
  "Green Frost": "#a8c8a8",
  "Green Mist": "#a8c8a8",
  "Green TB": "#2d7a2d",
  "Green Tea": "#8fbc8f",
  "GreenBay": "#1a5a1a",
  "Grey": "#9e9e9e",
  "Grey Camo": "#8a8a8a",
  "Grey Concrete": "#808080",
  "Grey Frost": "#c8d0d8",
  "Grey Heather": "#b0b0b0",
  "Grey Heather/ Black": "#b0b0b0",
  "Grey Melange": "#9e9e9e",
  "Grey Smoke": "#8a8a8a",
  "Grey Steel": "#708090",
  "Grey TB": "#9e9e9e",
  "Grey/ Black": "#9e9e9e",
  "Grey/ Charcoal/ Black": "#9e9e9e",
  "Grey/ Charcoal/ Navy": "#9e9e9e",
  "Grey/ Navy": "#9e9e9e",
  "Grey/ Red": "#9e9e9e",
  "Grey/ Royal": "#9e9e9e",
  "Grey/ White": "#9e9e9e",
  "Grey/ White/ Black Tri": "#9e9e9e",
  "Grey/Blue": "#7a8a9a",
  "Grey/White": "#9e9e9e",
  "GreyFrost": "#c8d0d8",
  "GreyHeather": "#9e9e9e",
  "GreySmoke": "#8a8a8a",
  "GreySteel": "#708090",
  "GreyTB": "#9e9e9e",
  "Greyed Out": "#9e9e9e",
  "GrphBlack": "#3a3a3a",
  "GrungeGrey": "#6b6b6b",
  "GrungeKhaki": "#b5a26b",
  "GryConHthr": "#9e9e9e",
  "Guava": "#f97b4f",
  "Gulfport Blue": "#1a6b8a",
  "GumPink": "#f4a7b9",
  "Gunmetal": "#2a2f35",
  "Gunmetal Heather": "#5a5a5a",
  "Gunmetal/ Chocolate Chip CMB": "#5A5A5A",
  "Gusty Grey": "#9e9e9e",
  "GyConcrete": "#808080",
  "GymBlue": "#1565c0",
  "HCanvasRd": "#c0392b",
  "HCarolinaB": "#6daedb",
  "HFrenchVan": "#f5e6c8",
  "HGalapagBl": "#3a9ab0",
  "HPnkGravel": "#c89090",
  "HSoftCream": "#fdf6e3",
  "Harbor Blue": "#4682b4",
  "HarborMist": "#c8d0d8",
  "HarborSlate": "#6b7280",
  "Harvest": "#c8891a",
  "Harvest Duck Camo/ Light Brown": "#4b5320",
  "Harvest Duck Camo/ Sandstone": "#4b5320",
  "Harvest Gold": "#c9941a",
  "HarvestOrg": "#c8891a",
  "HazyBlue": "#8aaac7",
  "HazyCoral": "#f08080",
  "HazyPurple": "#8b6b8b",
  "HazySunset": "#e8a080",
  "HdDstySage": "#b2ac88",
  "HdEuclpsBl": "#44d7a8",
  "Heather": "#b0b0b0",
  "Heather Aqua": "#6ecfd4",
  "Heather Autumn": "#c8834a",
  "Heather Azalea": "#ff69b4",
  "Heather Berry": "#8b0057",
  "Heather Blue": "#6699cc",
  "Heather Brown": "#8c5a2f",
  "Heather Burgundy": "#7a1a2e",
  "Heather Cardinal": "#9b2335",
  "Heather Cardinal Red": "#c0303a",
  "Heather Cardinal/ Black": "#9b2335",
  "Heather Caribbean Blue": "#1a8fa0",
  "Heather Carolina Blue": "#7aabcc",
  "Heather Charcoal": "#5c5c5c",
  "Heather Charcoal/ White": "#5c5c5c",
  "Heather Charity Pink": "#5c5c5c",
  "Heather Columbia Blue": "#7aabcc",
  "Heather Concrete": "#808080",
  "Heather CoolGrey": "#9faab5",
  "Heather CoolGrey/ Black": "#9faab5",
  "Heather Coral": "#f08080",
  "Heather Dark Chocolate": "#6b3a2a",
  "Heather Dark Green/ Silver": "#5a7a5a",
  "Heather Dark Grey": "#4a4a4a",
  "Heather Dark Loden": "#4b5320",
  "Heather Deep Teal": "#3d8a7a",
  "Heather Denim": "#5b7fa6",
  "Heather Desert Pink": "#e8a080",
  "Heather Dusty Rose": "#dcb0b0",
  "Heather Emerald": "#3a8a5a",
  "Heather Forest": "#5a7a5a",
  "Heather Galapagos": "#3a7a8a",
  "Heather Galapagos Blue": "#3a7a8a",
  "Heather Gold": "#c9941a",
  "Heather Granite": "#6b6b6b",
  "Heather Graphite": "#5c5c5c",
  "Heather Green": "#5a7a5a",
  "Heather Grey": "#b0b0b0",
  "Heather Grey/ Birch/ Amber Gold": "#9e9e9e",
  "Heather Grey/ Birch/ Army": "#9e9e9e",
  "Heather Grey/ Birch/ Army Olive": "#9e9e9e",
  "Heather Grey/ Birch/ Biscuit": "#9e9e9e",
  "Heather Grey/ Birch/ Cardinal": "#9e9e9e",
  "Heather Grey/ Birch/ Loden": "#9e9e9e",
  "Heather Grey/ Black": "#9e9e9e",
  "Heather Grey/ Charcoal/ Dark Orange": "#9e9e9e",
  "Heather Grey/ Charcoal/ Maroon": "#9e9e9e",
  "Heather Grey/ Dark Charcoal": "#9e9e9e",
  "Heather Grey/ Dark Green": "#9e9e9e",
  "Heather Grey/ Light Grey": "#9e9e9e",
  "Heather Grey/ Navy": "#9e9e9e",
  "Heather Grey/ Red": "#9e9e9e",
  "Heather Grey/ Royal": "#9e9e9e",
  "Heather Grey/ Rust": "#9e9e9e",
  "Heather Grey/ Stars & Stripes": "#9e9e9e",
  "Heather Grey/ White": "#9e9e9e",
  "Heather Gry/Bk": "#9e9e9e",
  "Heather Heliconia": "#ff3399",
  "Heather Indigo": "#4a5a8a",
  "Heather Irish Green": "#4a8a4a",
  "Heather Kelly": "#3a7a3a",
  "Heather Kelly Green": "#3a7a3a",
  "Heather Lapis": "#4a6fa0",
  "Heather Light Grey": "#c8c8c8",
  "Heather Light Navy": "#3a4a6b",
  "Heather Maroon": "#7a1a2e",
  "Heather Mauve": "#e0b0b0",
  "Heather Midnight Navy": "#2a3a5a",
  "Heather Military Green": "#5a6a3a",
  "Heather Mint": "#a0d8b0",
  "Heather Mustard": "#c8891a",
  "Heather Natural": "#e8d5a0",
  "Heather Navy": "#2a3a5a",
  "Heather Navy/ Light Grey": "#3a4a6b",
  "Heather New Navy": "#2a3a5a",
  "Heather New Olive": "#7a8a3a",
  "Heather Oatmeal": "#d4c9a8",
  "Heather Olive": "#7a8a3a",
  "Heather Orange": "#d47030",
  "Heather Orange/ Black": "#e8834a",
  "Heather Orchid": "#a06ba0",
  "Heather Peach": "#f5c0a0",
  "Heather Prism Dusty Blue": "#7a9fc0",
  "Heather Prism Dusty Lavender": "#c8a2c8",
  "Heather Prism Lilac": "#c8a2c8",
  "Heather Prism Mint": "#a0d8b0",
  "Heather Prism Natural": "#e8d5a0",
  "Heather Prism Peach": "#f5c0a0",
  "Heather Prism Seafoam": "#71eeb8",
  "Heather Prism Sunrise": "#ff6b35",
  "Heather Prism Sunset": "#ff6b35",
  "Heather Purple": "#6a4a8a",
  "Heather Radiant Orchid": "#da70d6",
  "Heather Raspberry": "#c71585",
  "Heather Red": "#9a4a4a",
  "Heather Red/ Light Grey": "#c0303a",
  "Heather Royal": "#4a6aaa",
  "Heather Royal Blue": "#3a5fa0",
  "Heather Royal/ Light Grey": "#3a5fa0",
  "Heather Sage": "#8fac7a",
  "Heather Sapphire": "#3a5a8a",
  "Heather Scarlet": "#c0303a",
  "Heather Sea Green": "#3a8a7a",
  "Heather Seafoam": "#71eeb8",
  "Heather Sienna": "#a05a3a",
  "Heather Slate": "#6a7a8a",
  "Heather Soft Cream": "#f0e8d8",
  "Heather Steel": "#708090",
  "Heather Stone": "#928e85",
  "Heather Storm": "#6b7a8a",
  "Heather Stormy": "#6b7a8a",
  "Heather Sunset": "#ff6b35",
  "Heather Teal": "#3d8a7a",
  "Heather Team Purple": "#5a2d82",
  "Heather Team Purple/ Black": "#5a2d82",
  "Heather True Navy": "#2a3a6b",
  "Heather True Royal": "#4a6aaa",
  "Heather True Royal/ Black": "#2a4fa0",
  "Heather Turquoise": "#40e0d0",
  "Heather Violet": "#6b3a9b",
  "Heather White/ Vintage Black": "#e8e8e8",
  "Heather Wine": "#7a1a2e",
  "Heather/ Black": "#9e9e9e",
  "Heather/ White": "#9e9e9e",
  "Heathered Char": "#c0303a",
  "Heathered Navy": "#3a4a6b",
  "HeathrDeepTeal": "#3d8a7a",
  "HeathrForest": "#5a7a5a",
  "HeathrMilGrn": "#6b7355",
  "HeavyMetal": "#555555",
  "HelBlue": "#4b9cd3",
  "Heliconia": "#d83070",
  "HeliconiaHTH": "#ff3399",
  "Hemp": "#9b8b6b",
  "HeriBrown": "#6b4c2a",
  "Hibiscus": "#b43757",
  "HighVizGrn": "#39ff14",
  "HighVizOrng": "#ff6600",
  "HighVizYlw": "#ffff00",
  "Honey": "#f5c800",
  "Honeydew": "#f0fff0",
  "Horizon Orange": "#ff6600",
  "Hot Pink/ Black": "#ffc0cb",
  "Hot Pink/ White": "#ffc0cb",
  "HotPink": "#ff69b4",
  "Houndstooth": "#444444",
  "Ht Aqua": "#00bcd4",
  "Ht Autumn": "#a0522d",
  "Ht Blue": "#6a8ab0",
  "Ht Brown": "#7a5040",
  "Ht Cardinal": "#7a2a2a",
  "Ht Charcoal": "#5c5c5c",
  "Ht Clay": "#b07050",
  "Ht Columb Blue": "#6daedb",
  "Ht Deep Teal": "#006060",
  "Ht Dust": "#b0a090",
  "Ht Dusty Blue": "#7a8aa0",
  "Ht Dusty Sage": "#b2ac88",
  "Ht Forest": "#2a5a2a",
  "Ht Grass Green": "#5a9a3a",
  "Ht Green": "#3a7a3a",
  "Ht Ice Blue": "#a0c8e0",
  "Ht Kelly": "#228b22",
  "Ht Kelly Green": "#2e6b2e",
  "Ht Lapis": "#3a4a9a",
  "Ht Maroon": "#7a2a3a",
  "Ht Mauve": "#9a7a8a",
  "Ht Midnight Ny": "#1a1a3a",
  "Ht Military Gn": "#5a6a3a",
  "Ht Mint": "#8ab8a0",
  "Ht Mustard": "#c8a030",
  "Ht Navy": "#2a3a5a",
  "Ht Olive": "#6b6b2a",
  "Ht Orange": "#d47030",
  "Ht Orchid": "#8a6a9a",
  "Ht Peach": "#d4a090",
  "Ht Prm Blue": "#2e5ead",
  "Ht Prm Dsty Bl": "#7a8aa0",
  "Ht Prm Ice Blu": "#a0c8e0",
  "Ht Prm Lilac": "#a088b8",
  "Ht Prm Mint": "#8ab8a0",
  "Ht Prm Natural": "#f0e8d8",
  "Ht Prm Peach": "#d4a090",
  "Ht Prm Sunset": "#e86830",
  "Ht Purple": "#800080",
  "Ht Raspberry": "#b03060",
  "Ht Red": "#9a4a4a",
  "Ht Russet": "#8B3A2A",
  "Ht Sea Green": "#3a8a6a",
  "Ht Slate": "#6a7a8a",
  "Ht Stone": "#8a8a7a",
  "Ht Storm": "#6a7a8a",
  "Ht Sunset": "#e86830",
  "Ht Tan": "#c8a060",
  "Ht Team Purple": "#4a2472",
  "Ht True Royal": "#2e5ead",
  "Ht Yellow": "#f5c518",
  "Ht Yellow Gold": "#c9a227",
  "HtBabyBlue": "#89cff0",
  "HtBluStorm": "#4a6a8a",
  "HtBrtTurq": "#00A0A8",
  "HtCardinal": "#7a2a2a",
  "HtCharcoal": "#5c5c5c",
  "HtClmbBl": "#6daedb",
  "HtDkChocBr": "#3C1F0F",
  "HtDkGrey": "#4a4a4a",
  "HtDpTeal": "#006060",
  "HtDstySage": "#b2ac88",
  "HtIrishGn": "#35a14a",
  "HtKllyGrn": "#2E7D32",
  "HtMltGrn": "#5a6a3a",
  "HtMustard": "#c8a030",
  "HtSangria": "#7B1040",
  "HtSapphire": "#3a5a8a",
  "HtdBrown": "#6b4c2a",
  "HtdCard": "#9B1B2A",
  "HtdChar": "#5c5c5c",
  "HtdDstyPch": "#E8A878",
  "HtdForGrn": "#2A5A2A",
  "HtdKelGn": "#2E7D32",
  "HtdNavy": "#003366",
  "HtdPurple": "#800080",
  "HtdRed": "#cc0000",
  "Hthr Ath Marn": "#9e9e9e",
  "Hthr Ath Mroon": "#9e9e9e",
  "Hthr Brown": "#9e9e9e",
  "Hthr Brt Turqu": "#9e9e9e",
  "Hthr Charcoal": "#555555",
  "Hthr Dk Ch Brn": "#9e9e9e",
  "Hthr Dk Chc Bn": "#9e9e9e",
  "Hthr Eggplant": "#9e9e9e",
  "Hthr Grey": "#b0b0b0",
  "Hthr Irish Grn": "#35a14a",
  "Hthr Mltry Grn": "#5a6a3a",
  "Hthr Navy": "#2a3a5a",
  "Hthr Purple": "#6a4a8a",
  "Hthr Red": "#9a4a4a",
  "Hthr Royal": "#4a6aaa",
  "Hthr Sangria": "#9e9e9e",
  "Hthr Sapphire": "#3a5a8a",
  "Hthr Teal": "#3a8a7a",
  "HthrAsh": "#b2b2b2",
  "HthrAthMar": "#9e9e9e",
  "HthrAthlGry": "#9e9e9e",
  "HthrAthlHthr": "#9e9e9e",
  "HthrBerry": "#6a1a4a",
  "HthrBlk": "#2d2d2d",
  "HthrBlue": "#6699cc",
  "HthrCabl": "#5b7fa6",
  "HthrCement": "#8a8a7a",
  "HthrChrcl": "#5c5c5c",
  "HthrCoolGry": "#9faab5",
  "HthrCrdnl": "#9b2335",
  "HthrDeepTeal": "#3d8a7a",
  "HthrDkNavy": "#3a4a6b",
  "HthrDust": "#b0a090",
  "HthrEmrld": "#2e8b57",
  "HthrForest": "#2a5a2a",
  "HthrGold": "#c9941a",
  "HthrGranite": "#6b6b6b",
  "HthrGray": "#b0b0b0",
  "HthrGrey": "#9e9e9e",
  "HthrGrn": "#5a7a5a",
  "HthrHaze": "#9e9e9e",
  "HthrHuntGrn": "#4a6a4a",
  "HthrIndigo": "#4a5a8a",
  "HthrIrishGrn": "#4a8a4a",
  "HthrKelly": "#3a7a3a",
  "HthrLapis": "#4a6fa0",
  "HthrMagnta": "#c0309a",
  "HthrMaroon": "#7a2a3a",
  "HthrMidNvy": "#2a3a5a",
  "HthrMilGrn": "#6b7355",
  "HthrMint": "#a0d8b0",
  "HthrMrn": "#7a1a2e",
  "HthrNatural": "#e8d5a0",
  "HthrNavy": "#2a3a5a",
  "HthrNewOlv": "#7a8a3a",
  "HthrOlive": "#6b6b2a",
  "HthrOrange": "#d47030",
  "HthrOrch": "#a06ba0",
  "HthrPeach": "#f5c0a0",
  "HthrPink": "#e07898",
  "HthrPrpl": "#7a3a9b",
  "HthrPurple": "#6a4a8a",
  "HthrRaspbry": "#c71585",
  "HthrRed": "#9a4a4a",
  "HthrRoyal": "#4a6aaa",
  "HthrRspbry": "#c71585",
  "HthrRusset": "#9e9e9e",
  "HthrSage": "#8a9a7a",
  "HthrScarlet": "#c0303a",
  "HthrSfGrn": "#3a8a7a",
  "HthrSienna": "#a05a3a",
  "HthrSilver": "#c0c0c0",
  "HthrSlate": "#6a7a8a",
  "HthrSoftCrm": "#f0e8d8",
  "HthrStone": "#928e85",
  "HthrStorm": "#6b7a8a",
  "HthrStormy": "#6b7a8a",
  "HthrSunset": "#ff6b35",
  "HthrTRRoy": "#4a6aaa",
  "HthrTeam Prpl": "#5a2d82",
  "HthrTmPrpl": "#4a2472",
  "HthrTruRoyal": "#2a4fa0",
  "HthrTruRyl": "#2a4fa0",
  "HthrTurq": "#40e0d0",
  "HthrViolet": "#6b3a9b",
  "HthrWine": "#7a1a2e",
  "Hthrd Brown": "#9e9e9e",
  "Hthrd Brt Turq": "#9e9e9e",
  "Hthrd Cardinal": "#9b2335",
  "Hthrd Charcoal": "#5c5c5c",
  "Hthrd Dsty Pch": "#9e9e9e",
  "Hthrd Dsty Sag": "#9e9e9e",
  "Hthrd Grey": "#9e9e9e",
  "Hthrd Kelly Gn": "#9e9e9e",
  "Hthrd Latte": "#9e9e9e",
  "Hthrd Lavender": "#9e9e9e",
  "Hthrd Navy": "#3a4a6b",
  "Hthrd Nep Blue": "#6699cc",
  "Hthrd Olive": "#9e9e9e",
  "Hthrd Purple": "#7a5a8a",
  "Hthrd Red": "#c0303a",
  "Hthrd Royal": "#3a5fa0",
  "Hthrd Steel": "#708090",
  "Hthrd Teal": "#3d8a7a",
  "HthrdGrey": "#9e9e9e",
  "HtrBluLagn": "#3a9ab0",
  "HtrBublGum": "#f07898",
  "HtrChrtyPk": "#f07898",
  "HtrCoolGry": "#9a9a9a",
  "HtrDkLvndr": "#7a5a9a",
  "HtrDpRoyal": "#3a5fa0",
  "HtrHelcona": "#c85070",
  "HtrNatural": "#f0e8d8",
  "HtrOatmeal": "#e8d8b8",
  "HtrRadOrcd": "#c070a0",
  "HtrScarRed": "#c0303a",
  "HtrSndDune": "#c8a870",
  "HtrdRoyal": "#3a5fa0",
  "HtrdRusset": "#8B3A2A",
  "Hunter": "#355e3b",
  "Hunter Green": "#355e3b",
  "Hunter Green/ Black": "#355e3b",
  "Hunter/ Black": "#355e3b",
  "Hunter/ Black/ White": "#355e3b",
  "Hunter/ Gold/ Black": "#355e3b",
  "Hunter/ Khaki": "#355e3b",
  "Hunter/ Orange": "#355e3b",
  "Hunter/ White": "#355e3b",
  "HunterGreen": "#355e3b",
  "HunterGrn": "#355e3b",
  "Hydrangea": "#B0A0D0",
  "Ice": "#e8f4f8",
  "Ice Blue": "#a0c8e0",
  "Ice Blue TB": "#a0c8e0",
  "Ice Grey": "#d8dce0",
  "IceBlue": "#a8d8e8",
  "IceBlue/ White": "#a8d8e8",
  "IceGrey": "#c0c8d0",
  "IceGreyHtr": "#d8dce0",
  "IcelndicPr": "#7A6A9A",
  "Impact Yellow": "#ffdd00",
  "Imperial Blue": "#1a3a8b",
  "Inca Gold": "#c9941a",
  "Inca Gold/ Black": "#c9941a",
  "IndBlue": "#1a3a8b",
  "IndiaInkGy": "#4A4A5A",
  "Indigo": "#4b0082",
  "Indigo Blue": "#3a4a9a",
  "Indigo Blue/ Birch": "#4b5fa0",
  "Indigo Sleeves/ Heather White Body": "#9e9e9e",
  "Indigo/ Birch": "#4b0082",
  "IndigoBlue": "#3a4a9a",
  "IndigoBlue/ Birch": "#4b5fa0",
  "InsBlue": "#1565c0",
  "IridescentBlue": "#5a8fa8",
  "Iris": "#5a4a9a",
  "Irish Green": "#35a14a",
  "IrishGreen": "#35a14a",
  "IrishGrn": "#009a44",
  "IrishGrnTB": "#009a44",
  "Iron Grey": "#9e9e9e",
  "IronGrey": "#6b6b6b",
  "IronGreyHt": "#9e9e9e",
  "Island Blue": "#1a8fa0",
  "Island Blue/ Birch": "#1a8fa0",
  "Island Green": "#1a7a4a",
  "Island Reef": "#1a8fa0",
  "IslandGrn": "#2A8A6A",
  "IslandReef": "#40B8C0",
  "Ivory": "#fffff0",
  "Jade": "#00a86b",
  "Jade Dome": "#1a8a7a",
  "Jade Green": "#2e6b2e",
  "JadeDome": "#1a8a7a",
  "JadeGreen": "#00a86b",
  "Jadeite": "#3A8A6A",
  "Jasmine": "#f5d060",
  "Jet Black": "#1c1c1c",
  "JetBlack": "#0a0a0a",
  "JewelGreen": "#2e6b2e",
  "JungleCamo": "#4b5320",
  "KaffaCof": "#5A3820",
  "Kelly": "#228b22",
  "Kelly Green": "#228b22",
  "Kelly Green Heather": "#5a7a5a",
  "Kelly/ Black": "#009a44",
  "Kelly/ Black/ Gold": "#009a44",
  "Kelly/ Black/ White": "#009a44",
  "Kelly/ Gold": "#009a44",
  "Kelly/ Navy": "#009a44",
  "Kelly/ Orange": "#009a44",
  "Kelly/ Red": "#009a44",
  "Kelly/ White": "#009a44",
  "Kelly/ White/ Black": "#009a44",
  "Kelly/ White/ Kelly": "#2E7D32",
  "KellyGreen": "#228b22",
  "KellyGrn": "#009a44",
  "KellyTB": "#009a44",
  "KellyTb": "#228b22",
  "Khaki": "#c8a96e",
  "Khaki/ Black": "#c3b091",
  "Khaki/ Black CMB": "#C8A870",
  "Khaki/ Black/ Khaki": "#c3b091",
  "Khaki/ Chocolate Chip CMB": "#C8A870",
  "Khaki/ Coffee": "#C8A870",
  "Khaki/ Forest": "#c3b091",
  "Khaki/ Forest Green": "#C8A870",
  "Khaki/ Legion Blue CMB": "#C8A870",
  "Khaki/ Loden": "#C8A870",
  "Khaki/ Loden Green CMB": "#C8A870",
  "Khaki/ Maroon": "#C8A870",
  "Khaki/ Navy": "#c3b091",
  "Khaki/ Navy CMB": "#C8A870",
  "Khaki/ Navy/ Stone": "#C8A870",
  "Khaki/ White": "#C8A870",
  "KhakiGold": "#c3b091",
  "KhakiGreen": "#2e6b2e",
  "KhakiTwill": "#c3b091",
  "Kiwi": "#78c020",
  "Kiwi Green": "#8ee53f",
  "KiwiGreen": "#2e6b2e",
  "Kryptek Highlander": "#8A9A7A",
  "Kryptek Highlander - Buck": "#8A9A7A",
  "Kryptek Highlander/ Buck": "#8A9A7A",
  "Kryptek Inferno/ Black": "#8A3A2A",
  "Kryptek Inferno/ Blaze Orange": "#C86030",
  "Kryptek Neptune/ Black": "#3A5A6A",
  "Kryptek Neptune/ White": "#3A5A6A",
  "Kryptek Pontus": "#2A4A5A",
  "Kryptek Pontus/ White": "#2A4A5A",
  "Kryptek Raid": "#6A6A5A",
  "Kryptek Typhon": "#3A3A3A",
  "Kryptek Typhon/ Black": "#3A3A3A",
  "Kryptek Typhon/ Neon Orange": "#3A3A3A",
  "Kryptek Typhon/ Neon Pink": "#3A3A3A",
  "Kryptek Typhon/ Neon Yellow": "#3A3A3A",
  "Kryptek Wraith": "#C8C8B8",
  "Lagoon": "#1A8A9A",
  "Lagoon Blue": "#1a8fa0",
  "Lake": "#1a6b8a",
  "Lake Blue": "#1a6b8a",
  "LakeBlue": "#1a6b8a",
  "LakeBlueHtr": "#4682b4",
  "Lakeshore": "#4a7a9a",
  "Latte": "#C8A882",
  "LaurelGrn": "#5A7A3A",
  "LavBlueHtr": "#b2a2cc",
  "LavHthr": "#b2a2cc",
  "Lavender": "#e6e6fa",
  "Lavender Blue": "#8080cc",
  "Lavender/ White": "#967bb6",
  "LavenderBl": "#a0a0e0",
  "LavenderBlue": "#8080cc",
  "LavenderHtr": "#b2a2cc",
  "Leaf": "#5a8a3a",
  "Leafy Green": "#5a8a1a",
  "Lemon": "#fff44f",
  "Lemon Yellow": "#F5E030",
  "Lemon Zest": "#fff44f",
  "LemonYllw": "#F5E030",
  "Lemongrass": "#8A9A3A",
  "LghtGryHtr": "#c8c8c8",
  "Light Blue": "#87ceeb",
  "Light Blue Heather": "#add8e6",
  "Light Blue/ Black": "#add8e6",
  "Light Blue/ Light Grey CMB": "#1565c0",
  "Light Blue/ Navy/ White": "#add8e6",
  "Light Blue/ Sand": "#1565c0",
  "Light Blue/ White": "#add8e6",
  "Light Charcoal": "#6b6b6b",
  "Light Charcoal/ Black": "#6b6b6b",
  "Light Gray": "#d3d3d3",
  "Light Green": "#90ee90",
  "Light Green/ White": "#2e6b2e",
  "Light Grey": "#d3d3d3",
  "Light Grey/ Black": "#d3d3d3",
  "Light Grey/ Charcoal": "#9e9e9e",
  "Light Grey/ Navy/ White": "#d3d3d3",
  "Light Grey/ White": "#9e9e9e",
  "Light Heather Grey": "#c8c8c8",
  "Light Hthr Gry": "#9e9e9e",
  "Light Lemon": "#fff44f",
  "Light Loden": "#8a9a6a",
  "Light Navy": "#003366",
  "Light Olive/ Olive": "#808000",
  "Light Olive/ Stone": "#808000",
  "Light Oxford": "#c8c8c8",
  "Light Oxford/ Black": "#c8c8c8",
  "Light Oxford/ Navy": "#c8c8c8",
  "Light Pink": "#f0b0c0",
  "Light Plum": "#9b6b9b",
  "Light Sand": "#E8D8B0",
  "Light Steel": "#b0c4de",
  "Light Steel Blue": "#b0c4de",
  "Light Tan": "#D4B896",
  "Light Yellow": "#fffacd",
  "LightBlue": "#87ceeb",
  "LightCharcoal": "#6b6b6b",
  "LightGold": "#e8d080",
  "LightGray": "#c8c8c0",
  "LightGreen": "#2e6b2e",
  "LightGrey": "#c8c8c0",
  "LightLoden": "#8a9a6a",
  "LightOlive": "#8a8a5a",
  "LightOrange": "#ffb347",
  "LightOxford": "#c8c8c8",
  "LightPink": "#f0b0c0",
  "LightPlum": "#9b6b9b",
  "LightPurple": "#c8a2c8",
  "LightSand": "#E8D8B0",
  "LightSteelBlue": "#b0c4de",
  "LightTeal": "#7ec8c8",
  "LightYellow": "#ffff99",
  "LightYllw": "#F8F0A0",
  "Lilac": "#c8a0d8",
  "Lilac Heather": "#c8a2c8",
  "Lilac TB": "#c8a0d8",
  "Lilac/ Birch": "#C8B0D8",
  "Lilac/ White-Grey": "#9e9e9e",
  "Lime": "#bfff00",
  "Lime Green": "#32cd32",
  "Lime Shock": "#8fc63c",
  "LimeGreen": "#32cd32",
  "LimePunch": "#b5e61d",
  "LimeShock": "#b5e61d",
  "Linden Green": "#6b8a3a",
  "Linen": "#faf0e6",
  "Linen/ Navy": "#faf0e6",
  "LinenNavy": "#faf0e6",
  "LiteBlue": "#add8e6",
  "Loden": "#6b6b2a",
  "Loden Green": "#2e6b2e",
  "Loden Green/ Black": "#2e6b2e",
  "Loden/ Amber Gold": "#4A6A2A",
  "Loden/ Black": "#4A6A2A",
  "Loden/ Green Camo": "#4A6A2A",
  "Loden/ Khaki": "#4A6A2A",
  "Lt Blue Hthr": "#add8e6",
  "Lt Hthr Grey": "#9e9e9e",
  "Lt Pink": "#ffb6c1",
  "Lt Turquoise": "#7AD4D8",
  "LtBlue": "#add8e6",
  "LtCharcoal": "#6b6b6b",
  "LtGold": "#e8d080",
  "LtGrey": "#d3d3d3",
  "LtHeather": "#c8c8c8",
  "LtHtGry": "#C8C8C0",
  "LtLoden": "#8a9a6a",
  "LtOliveHtr": "#A0A870",
  "LtOrange": "#ffb347",
  "LtOxford": "#c8c8c8",
  "LtPink": "#ffb6c1",
  "LtPlum": "#9b6b9b",
  "LtPurple": "#c8a2c8",
  "LtSteel": "#b0c4de",
  "LtSteelBlue": "#b0c4de",
  "LtTurq": "#7AD4D8",
  "LtViolet": "#c8a0d8",
  "LtYellow": "#ffff99",
  "LucidGreen": "#2e6b2e",
  "LvndrDust": "#b0a8c8",
  "Magenta": "#ff00ff",
  "Magnolia": "#f8f4e3",
  "Magnolia/ Black": "#f8f4e3",
  "Maize": "#f5d060",
  "Maize Yellow": "#f5c518",
  "Majestic Purple": "#5a1a7a",
  "Mandarin Orange": "#f28500",
  "Mango": "#ff8c00",
  "MangoSorbet": "#ff8c00",
  "MariBlue": "#1565c0",
  "MarigldHtr": "#E89030",
  "Marigold": "#f5c800",
  "MarigoldHthr": "#e8c060",
  "Marine": "#1a4a6b",
  "Marine Blue/ Navy/ White": "#1565c0",
  "MarineBlue": "#003366",
  "Maritime Blue": "#1565c0",
  "Maritime Frost": "#A0B8C8",
  "Marl Grey": "#9e9e9e",
  "MarlGrey": "#9e9e9e",
  "Marmalade": "#e8834a",
  "Maroon": "#7b1c2a",
  "Maroon Frost": "#800000",
  "Maroon Hthr": "#7a1a2e",
  "Maroon TB": "#7b1c2a",
  "Maroon/ Black": "#800000",
  "Maroon/ Black/ White": "#800000",
  "Maroon/ Cardinal": "#800000",
  "Maroon/ Gold": "#800000",
  "Maroon/ Gold/ Black": "#800000",
  "Maroon/ Gold/ White": "#800000",
  "Maroon/ Grey": "#800000",
  "Maroon/ Old Gold": "#800000",
  "Maroon/ Silver": "#800000",
  "Maroon/ Vegas Gold": "#800000",
  "Maroon/ White": "#800000",
  "Maroon/ White/ Maroon": "#800000",
  "Maroon/Gold": "#800000",
  "Maroon/Wht": "#800000",
  "Marsh Duck Camo/ Loden": "#4b5320",
  "Marsh Duck Camo/ Loden Green": "#4b5320",
  "Marsh Duck Camo/ Olive Green": "#4b5320",
  "Maui Blue": "#1565c0",
  "Mauve": "#9a7a8a",
  "Mauve TB": "#9a7a8a",
  "MauveHthr": "#e0b0b0",
  "MdntNavy": "#1a1a3a",
  "MeadowGrn": "#5A9A3A",
  "Med. Blue": "#1565c0",
  "Medium Blue": "#0000cd",
  "Medium Gray": "#9e9e9e",
  "Medium Grey": "#9e9e9e",
  "MediumGrey": "#9e9e9e",
  "Melon": "#f5a57a",
  "MelonPink": "#f5a57a",
  "Metal": "#6b7280",
  "Metal Grey": "#9e9e9e",
  "MetalGrey": "#9e9e9e",
  "Metro Blue": "#1565c0",
  "MetroBlue": "#3a5a8a",
  "MidGrey": "#9e9e9e",
  "MidHthrGry": "#9e9e9e",
  "Midnight": "#1a1a3a",
  "Midnight Blue": "#001a33",
  "Midnight Navy": "#001a33",
  "Midnight Navy/ White": "#003366",
  "Midnight/ Black": "#001a33",
  "MidnightBlue": "#001a33",
  "MidnightNavy": "#001a33",
  "MilGreen": "#3a4a2a",
  "MilGrnFst": "#7A9A7A",
  "MilGrnHthr": "#6b7355",
  "Military Digital Camo/ Light Green": "#4b5320",
  "Military Green": "#3a4a2a",
  "Military Green/ Black": "#6b7355",
  "Military Grn F": "#4A6A2A",
  "MilitaryGrn": "#6b7355",
  "Militry Grn TB": "#3a4a2a",
  "MindfulBlu": "#5A7A9A",
  "Mink Beige/ Charcoal/ Amber Gold": "#C8B090",
  "Mint": "#98c8a0",
  "Mint Blue": "#98d8c8",
  "Mint Green": "#98c8a0",
  "Mint TB": "#98c8a0",
  "MintBlue": "#98d8c8",
  "MintChip": "#98ff98",
  "MintGreen": "#98c8a0",
  "MintJulep": "#98ff98",
  "Mist": "#c8d8e8",
  "MistBlue": "#c8d8e8",
  "Misty Blue": "#1565c0",
  "MistyJade": "#8AB8A8",
  "Mocha": "#6f4e37",
  "MochaBrown": "#6f4e37",
  "MochaHTH": "#7a5a4a",
  "MochaTweed": "#7a5c3a",
  "ModernCamo": "#4b5320",
  "MoonlightBlue": "#4682b4",
  "Moonstone Blue": "#5a8fa8",
  "Moss": "#6b7c4a",
  "Moss Green": "#6b8a3a",
  "Moss/ Khaki": "#7A8A4A",
  "MossGreen": "#6b8a3a",
  "MossHTH": "#6b8a3a",
  "Mossy Oak Bottomland/ Black": "#4A4A3A",
  "Mossy Oak Bottomland/ Loden": "#4A5A3A",
  "Mossy Oak Bottomland/ Loden Green": "#4A5A3A",
  "Mossy Oak Country DNA/ Black": "#6A6A4A",
  "Mossy Oak Elements Blacktip/ Charcoal": "#111111",
  "Mossy Oak Elements Bonefish/ Light Grey": "#9e9e9e",
  "Mossy Oak Habitat/ Brown": "#7A6A4A",
  "Mossy Oak Obsession/ Khaki": "#5A6A3A",
  "MrnTB": "#800000",
  "MudBrown": "#6b4c2a",
  "Mulberry": "#7a1a4a",
  "MulberryHTH": "#7a1a4a",
  "Mulch": "#6b4c2a",
  "Mulitcam Black": "#111111",
  "MultiBrown": "#6b4c2a",
  "MultiCamo": "#4b5320",
  "Multicam Alpine": "#C8D0C0",
  "Multicam Alpine/ White": "#C8D0C0",
  "Multicam Arid": "#C8B87A",
  "Multicam Arid/ Brown": "#C8B87A",
  "Multicam Arid/ Tan": "#C8B87A",
  "Multicam Black": "#111111",
  "Multicam Black/ Black": "#111111",
  "Multicam Green": "#2e6b2e",
  "Multicam Green/ Black": "#2e6b2e",
  "Multicam Green/ Khaki": "#2e6b2e",
  "Multicam Original/ Coyote Brown": "#A08A5A",
  "Multicam Tropic": "#5A8A5A",
  "Multicam Tropic/ Green": "#5A8A5A",
  "Multicam Tropic/ Loden Green": "#5A8A5A",
  "Mushroom": "#9a8878",
  "Mushroom/ Black": "#9a8878",
  "Mustard": "#c8a030",
  "Mustard Tb": "#c8a030",
  "MutedBlue": "#7a9fc0",
  "MutedGreen": "#5a7a5a",
  "MutedNavy": "#1a2a4a",
  "MutedPurple": "#8b6b8b",
  "Mystic": "#5A6A8A",
  "NCantloupe": "#F8A070",
  "Nantucket Red": "#cc0000",
  "Nat/DeepBk": "#f5f0e0",
  "Nat/DeepRd": "#f5f0e0",
  "Nat/RvBlNv": "#f5f0e0",
  "Natural": "#f5f0e0",
  "Natural/ Black": "#f5f0e0",
  "Natural/ Brown": "#F5EDD8",
  "Natural/ Camo Green": "#F5EDD8",
  "Natural/ Charcoal": "#F5EDD8",
  "Natural/ Forest Green": "#F5EDD8",
  "Natural/ Khaki": "#F5EDD8",
  "Natural/ Maroon": "#F5EDD8",
  "Natural/ Mossy Oak Breakup": "#F5EDD8",
  "Natural/ Navy": "#F5EDD8",
  "Natural/ Realtree All Purpose": "#F5EDD8",
  "Natural/ Red": "#F5EDD8",
  "Natural/ Royal": "#F5EDD8",
  "NaturalHTH": "#e8d5a0",
  "NaturalRaw": "#F5EDD8",
  "NatyHTH": "#e8d5a0",
  "Navy": "#1a2848",
  "Navy Blue": "#003366",
  "Navy Frost": "#003366",
  "Navy Heather": "#3a4a6b",
  "Navy TB": "#1a2848",
  "Navy/ Birch/ Red": "#003366",
  "Navy/ Black": "#003366",
  "Navy/ Black/ Gold": "#003366",
  "Navy/ Black/ White": "#003366",
  "Navy/ Carmel": "#003366",
  "Navy/ Charcoal": "#003366",
  "Navy/ Columbia": "#003366",
  "Navy/ Dark Orange/ Dark Orange": "#003366",
  "Navy/ Gold": "#003366",
  "Navy/ Gold/ White": "#003366",
  "Navy/ Graphite": "#003366",
  "Navy/ Graphite/ White": "#003366",
  "Navy/ Kelly": "#003366",
  "Navy/ Khaki": "#003366",
  "Navy/ Khaki CMB": "#003366",
  "Navy/ Light Grey": "#003366",
  "Navy/ Light Grey/ White": "#003366",
  "Navy/ Maroon": "#003366",
  "Navy/ Midnight Navy-Grey Blue": "#003366",
  "Navy/ Navy": "#003366",
  "Navy/ Orange": "#003366",
  "Navy/ Orange/ White": "#003366",
  "Navy/ Purple": "#003366",
  "Navy/ Red": "#003366",
  "Navy/ Red/ White": "#003366",
  "Navy/ Royal": "#003366",
  "Navy/ Royal/ White": "#003366",
  "Navy/ Silver": "#003366",
  "Navy/ Stone Stitch": "#003366",
  "Navy/ Vegas Gold": "#003366",
  "Navy/ White": "#003366",
  "Navy/ White Split": "#003366",
  "Navy/ White/ Gold": "#003366",
  "Navy/ White/ Heather Grey": "#003366",
  "Navy/ White/ Navy": "#003366",
  "Navy/ White/ Red": "#003366",
  "Navy/ White/ Red Tri": "#003366",
  "Navy/Black": "#003366",
  "Navy/Gold": "#003366",
  "Navy/Kelly": "#003366",
  "NavyBlue": "#1a2848",
  "NavyBlueHTH": "#3a4a6b",
  "NavyGold": "#003366",
  "NavyGold/ White": "#003366",
  "NavyHthr": "#3a4a6b",
  "NavyOrange": "#003366",
  "NavyTB": "#003366",
  "NeElecCorl": "#FF6060",
  "Neon Blue": "#1a90ff",
  "Neon Blue/ Black": "#00ffff",
  "Neon Coral": "#ff6b6b",
  "Neon Coral/ Black": "#ff6b6b",
  "Neon Green": "#39d000",
  "Neon Green/ Black": "#39ff14",
  "Neon Lemon": "#ffff00",
  "Neon Orange": "#ff5f00",
  "Neon Orange/ Black": "#ff6600",
  "Neon Pink": "#ff3f7a",
  "Neon Pink/ Black": "#ff69b4",
  "Neon Purple": "#bc13fe",
  "Neon Red": "#ff3131",
  "Neon Red Orng": "#cc0000",
  "Neon Yellow": "#e8f200",
  "Neon Yellow/ Black": "#ffff00",
  "NeonBlue": "#1a90ff",
  "NeonGreen": "#2e6b2e",
  "NeonLemon": "#F5FF00",
  "NeonOrange": "#ff5f00",
  "NeonPink": "#ff3f7a",
  "NeonRdOrng": "#FF3010",
  "NeonVio": "#CC00FF",
  "NeonYellow": "#e8f200",
  "NeonYlw": "#ffff00",
  "Neptune Blue": "#1565c0",
  "NeptuneBl": "#1A5A8A",
  "New French Navy": "#002366",
  "New Navy": "#1a2848",
  "New Railroad Grey": "#9e9e9e",
  "New Red": "#c0392b",
  "NewNavy": "#003087",
  "NewRdHthr": "#9e9e9e",
  "Nickel": "#7A7A7A",
  "Nickel Heather/ Black": "#9e9e9e",
  "Nickel Heather/ Forest Camo": "#9e9e9e",
  "Night": "#001a33",
  "Night/ Black": "#001a33",
  "NightBlue": "#001a33",
  "NightGreen": "#1a3a1a",
  "NightHTH": "#2a3a5a",
  "NightMint": "#001a33",
  "NightNavy": "#003366",
  "NightPurple": "#1a003a",
  "NightTeal": "#001a1a",
  "NightViolet": "#1a003a",
  "Nispero": "#C87840",
  "NordHTH": "#4682b4",
  "NstlgiaRse": "#C87880",
  "NtSky Bl/DB Ny": "#5A9AD0",
  "NthWoodsHt": "#3a5a3a",
  "Nw Taupe Grn H": "#9A9A7A",
  "OakBrown": "#6b4c2a",
  "Oasis Green/ White": "#2e6b2e",
  "Oat Milk": "#F0E8D0",
  "Oat Milk/ Elmwood-White": "#F0E8D0",
  "OatHTH": "#e8d5a0",
  "OatHthr": "#d8cfc0",
  "OatNatural": "#e8d5a0",
  "Oatmeal": "#e8d8b8",
  "Oatmeal Heather": "#d4c9a8",
  "Oatmeal Hthr": "#d4c9a8",
  "Oatmeal TB": "#e8d8b8",
  "OatmealHTH": "#d4c9a8",
  "Ocean": "#1a6b8a",
  "Ocean Blue": "#2a6a9a",
  "Ocean Depths": "#1A4A6A",
  "Ocean Green": "#1a7a4a",
  "Ocean Green/ Birch": "#1a7a4a",
  "OceanBlue": "#1a6b8a",
  "OceanBlueHTH": "#3a7a8a",
  "OceanDepth": "#1A4A6A",
  "OceanGreen": "#1a7a4a",
  "OceanGreenHTH": "#1a7a4a",
  "OceanHthr": "#3a7a8a",
  "OchreYlw": "#C8900A",
  "OchreYlwHr": "#C8900A",
  "OdGold": "#c5b358",
  "Off White": "#ffffff",
  "OffWhite": "#f5f0e8",
  "Old Gold/ Black": "#c5b358",
  "Old Gold/ Navy": "#c5b358",
  "OldGold": "#c5b358",
  "Olive": "#6b6b2a",
  "Olive Drab": "#6b6b2a",
  "Olive Drab Grn": "#808000",
  "Olive Green": "#6b7a1a",
  "Olive Night": "#4a4a2a",
  "Olive TB": "#6b6b2a",
  "Olive/ Black": "#808000",
  "Olive/ Stone Stitch": "#808000",
  "OliveGold": "#808000",
  "OliveGreen": "#6b7a1a",
  "OliveHTH": "#7a8a3a",
  "OliveNight": "#4a4a2a",
  "OliveNightHTH": "#4a4a2a",
  "OliveOil": "#808000",
  "OlvDrabGn": "#6B6B2A",
  "OlvDrabGnH": "#6B6B2A",
  "Ombre Blue/ Navy": "#1565c0",
  "OpalWhite": "#ffffff",
  "Orange": "#e8531a",
  "Orange Frost": "#f5a057",
  "Orange Heather": "#e8834a",
  "Orange Sherbet": "#ff6600",
  "Orange TB": "#e8531a",
  "Orange/ Black": "#ff6600",
  "Orange/ Black/ White": "#ff6600",
  "Orange/ Forest": "#ff6600",
  "Orange/ Gold": "#ff6600",
  "Orange/ Navy": "#ff6600",
  "Orange/ White": "#ff6600",
  "Orange/ White/ Black": "#ff6600",
  "OrangeCrush": "#e65100",
  "OrangeGold": "#e8834a",
  "OrangeHTH": "#e8834a",
  "OrangeHthr": "#e8834a",
  "OrangePunch": "#ff6600",
  "OrchdHTH": "#da70d6",
  "Orchid": "#8a6a9a",
  "Orchid Ice": "#e0b0e0",
  "Orchid Tb": "#8a6a9a",
  "OrchidHaze": "#B89AB8",
  "OxBlood": "#800020",
  "Oxblood": "#5a1020",
  "Oxblood Black": "#3a0810",
  "Oxford": "#c8c8c8",
  "Oxford/ Black": "#c8c8c8",
  "Oxford/ Navy": "#c8c8c8",
  "Oxford/ Red": "#c8c8c8",
  "OxfordGrey": "#c8c8c8",
  "Pacific": "#2A7AA0",
  "Pacific Blue": "#1a6b8a",
  "Pacific Teal": "#00827f",
  "PacificBlue": "#1a6b8a",
  "PacificTeal": "#00827f",
  "Pale Khaki/ Loden Green": "#D4C898",
  "Pale Peach/ Maroon": "#F8D0B8",
  "Pale Pink": "#f0c8d0",
  "PaleBlush": "#F8D8D0",
  "PaleYllwTb": "#fffacd",
  "Paprika": "#c0303a",
  "Parachute Purple": "#5a2d82",
  "Paragon": "#6a7a8a",
  "Parchment": "#F5EDD0",
  "ParisHTH": "#4682b4",
  "ParisianBl": "#2A3A8A",
  "Pastel Purple": "#800080",
  "PastelBlue": "#aec6cf",
  "PastelGreen": "#77dd77",
  "PastelPink": "#ffb7d5",
  "PastelPink/ White": "#ffb7d5",
  "PastelPurple": "#c8a2c8",
  "PastelYellow": "#fdfd96",
  "Patina Green/ Birch": "#2e6b2e",
  "PatinaHTH": "#8fbc8f",
  "PatriotBlue": "#1a3a8b",
  "Peach": "#ffcba4",
  "Peach TB": "#ffcba4",
  "PeachBlush": "#f5c0a0",
  "PeachFrost": "#f5c0a0",
  "PeachHTH": "#f5c0a0",
  "Peachy": "#F8A880",
  "PeacoatNavy": "#1a2a4a",
  "PearGreen": "#d1e231",
  "Pearl Grey Hth": "#9e9e9e",
  "PearlHTH": "#f0f0e0",
  "Pebble": "#c0b8a8",
  "Pebble Brown": "#8a7060",
  "Pebble Heather": "#c0b8a8",
  "Pebblestone": "#9A9080",
  "Peony Pink": "#ffc0cb",
  "Pepper": "#6a6a6a",
  "Pepper Heather": "#4a4a4a",
  "PepperGrey": "#4a4a4a",
  "PepperHTH": "#4a4a4a",
  "PeriBlue": "#6a7ab0",
  "Periwinkle": "#AAAACC",
  "PersianBlue": "#1c39bb",
  "Petal": "#f4a7b9",
  "Petrol Bl/Navy": "#1A3A5A",
  "Petrol Blue": "#1565c0",
  "Petrol Grey": "#9e9e9e",
  "Pewter": "#8a9a8a",
  "PicoBlu": "#1a6b8a",
  "Pigment Alpine Green": "#2E6B3E",
  "Pigment Amber": "#C8882A",
  "Pigment Army": "#4B5320",
  "Pigment Black": "#1C1C1C",
  "Pigment Burro": "#C4A882",
  "Pigment Cement": "#8C8C7A",
  "Pigment Clay": "#A0614A",
  "Pigment Dusty Pink": "#D4909A",
  "Pigment French Oak": "#A0785A",
  "Pigment Grape Ice": "#9B72AA",
  "Pigment Ivory": "#F5EDD8",
  "Pigment Light Blue": "#7BAEC8",
  "Pigment Lunar Rock": "#7A7A7A",
  "Pigment Maroon": "#7A1A28",
  "Pigment Midnight Navy": "#003366",
  "Pigment Mint": "#9ECFB8",
  "Pigment Oil Green": "#3A5A2A",
  "Pigment Peanut Butter": "#C8965A",
  "Pigment Pebble Blue": "#6A8AA0",
  "Pigment Pink": "#E8A0AA",
  "Pigment Pistachio": "#8FAF72",
  "Pigment Plum": "#6B2D5E",
  "Pigment Sage": "#8A9A6A",
  "Pigment Salmon": "#E88878",
  "Pigment Sandstone": "#C8A87A",
  "Pigment Slate Blue": "#5A7A9A",
  "Pigment Tornado": "#6A7A8A",
  "Pigment Yellow": "#E8C840",
  "Pine": "#2a5a2a",
  "Pine Green": "#2e5e2e",
  "PineBrook": "#2e5e2e",
  "PineGreen": "#2e5e2e",
  "PineHTH": "#4a6a4a",
  "Pink": "#f07898",
  "Pink Camo": "#4b5320",
  "Pink Heather": "#f4a7b9",
  "Pink Lemonade": "#f5c0d0",
  "Pink Raspberry": "#c71585",
  "Pink/ White": "#ffc0cb",
  "Pink/ White/ Pink": "#ffc0cb",
  "PinkCoral": "#f08080",
  "PinkFlamingo": "#f08080",
  "PinkFrost": "#f5d0d8",
  "PinkGravel": "#c89090",
  "PinkHTH": "#f4a7b9",
  "PinkHthr": "#f4a7b9",
  "PinkIce": "#ffdde1",
  "PinkLavender": "#f4a7b9",
  "PinkLemonade": "#f5c0d0",
  "PinkLilyHTH": "#f4a7b9",
  "PinkMagenta": "#de5285",
  "PinkMink": "#f4a7b9",
  "PinkMocha": "#e8b0b0",
  "PinkNeon": "#ff69b4",
  "PinkRaspberry": "#c71585",
  "PinkTB": "#f07898",
  "PinkTuliip": "#f08080",
  "PinkViolet": "#f4a7b9",
  "Pistachio": "#93c47d",
  "Platinum": "#C0C0C8",
  "Plum": "#8b1c62",
  "PlumCrazy": "#8b0057",
  "PlumHTH": "#8b0057",
  "PlumMist": "#8b6b8b",
  "PlumPunchHTH": "#8b0057",
  "PlumPurple": "#8b0057",
  "PlutoniumHTH": "#708090",
  "Pomegranate": "#C0182A",
  "Pool Blue": "#1565c0",
  "PoolBlue": "#1565c0",
  "Poppy": "#e83030",
  "Poppy Red": "#cc3333",
  "Port": "#7b1c2a",
  "Port Royale": "#5a1a2a",
  "PortalHTH": "#5a1a2a",
  "Poseidon Black": "#111111",
  "Powder": "#b0e0e6",
  "Powder Blue": "#b0e0e6",
  "Powder Pink": "#ffb7d5",
  "PowderBlueHTH": "#b0e0e6",
  "PowderPinkHTH": "#ffb7d5",
  "Power Blue": "#1a52c7",
  "PrairieHTH": "#c2b280",
  "Premium Heather Sleeves/ Heather White Body": "#9e9e9e",
  "Premium Heather Sleeves/ Vintage Black Body": "#9e9e9e",
  "PremiumHTH": "#A8A8A0",
  "PremiumHeather": "#9e9e9e",
  "Prepared For Dye": "#F0EBE0",
  "Prism Lilac": "#c8a2c8",
  "Prism Mint": "#a0d8b0",
  "Prism Peach": "#f5c0a0",
  "PrismGrn": "#a0d8b0",
  "PrismLilac": "#c8a2c8",
  "PrismMint": "#a0d8b0",
  "PrismPeach": "#f5c0a0",
  "PrismSeafoam": "#71eeb8",
  "PrismSunrise": "#ff6b35",
  "PrismSunset": "#ff6b35",
  "PrismYellow": "#fff44f",
  "PrplHTH": "#7a3a9b",
  "Purple": "#6a4a8a",
  "Purple Frost": "#800080",
  "Purple Haze": "#7a3a9b",
  "Purple Heather": "#7a3a9b",
  "Purple Plum Raisin": "#800080",
  "Purple Rush Sleeves/ Heather White Body": "#800080",
  "Purple Storm": "#5a1a7a",
  "Purple TB": "#6a4a8a",
  "Purple/ Black": "#800080",
  "Purple/ Black/ White": "#800080",
  "Purple/ Gold": "#800080",
  "Purple/ Gold/ White": "#800080",
  "Purple/ Silver": "#800080",
  "Purple/ White": "#800080",
  "Purple/ White/ Purple": "#800080",
  "PurpleBlack": "#800080",
  "PurpleBlueHTH": "#5a2d82",
  "PurpleCamo": "#5a2d82",
  "PurpleGold": "#800080",
  "PurpleGoldHTH": "#800080",
  "PurpleHTH": "#7a3a9b",
  "PurpleHaze": "#7a3a9b",
  "PurpleLove": "#800080",
  "PurpleNavy": "#800080",
  "PurpleOrchid": "#da70d6",
  "PurpleRose": "#800080",
  "PurpleRush": "#5a2a8a",
  "PurpleStrm": "#5a4a7a",
  "Putty": "#d4c9a8",
  "Quarry Grey": "#9e9e9e",
  "Quarry/ Quarry": "#9A9080",
  "QuarryHTH": "#928e85",
  "RacingGreen": "#004225",
  "Rainforest": "#2A6A3A",
  "RanchGreen": "#4a6a3a",
  "RanchHTH": "#8c6b4a",
  "Raspberry Flck": "#C03060",
  "RaspberryBeret": "#c71585",
  "RaspberryHTH": "#c71585",
  "RavenHTH": "#2a2a2a",
  "RdTB": "#cc0000",
  "Realtree Advantage/ Khaki": "#7A7A5A",
  "Realtree Edge/ Brown": "#7A6A4A",
  "Realtree Edge/ Neon Orange": "#7A6A4A",
  "Realtree Edge/ Neon Pink": "#7A6A4A",
  "Realtree Edge/ Neon Yellow": "#7A6A4A",
  "Realtree Fishing Light Blue/ Navy": "#1565c0",
  "Realtree Fishing Light Blue/ White": "#1565c0",
  "Realtree Max 7/ Buck": "#8A8A6A",
  "Realtree Max-1/ Brown": "#8A7A5A",
  "Realtree Max-7/ Buck": "#8A8A6A",
  "Realtree Max7/ Brown": "#8A8A6A",
  "Realtree Original/ Black": "#6A6A4A",
  "Realtree Timber/ Black": "#7A7A5A",
  "Red": "#c0392b",
  "Red Buffalo Plaid": "#cc0000",
  "Red Fleck": "#cc0000",
  "Red Frost": "#cc0000",
  "Red Heather": "#c0303a",
  "Red Heather/ Black": "#c0303a",
  "Red Pepper": "#c0303a",
  "Red TB": "#c0392b",
  "Red/ Black": "#cc0000",
  "Red/ Black/ Gold": "#cc0000",
  "Red/ Black/ White": "#cc0000",
  "Red/ Charcoal": "#cc0000",
  "Red/ Charcoal/ Black": "#cc0000",
  "Red/ Charcoal/ Black Tri": "#cc0000",
  "Red/ Gold": "#cc0000",
  "Red/ Grey": "#cc0000",
  "Red/ Navy": "#cc0000",
  "Red/ Silver": "#cc0000",
  "Red/ White": "#cc0000",
  "Red/ White/ Black": "#cc0000",
  "Red/ White/ Blue": "#cc0000",
  "Red/ White/ Gold": "#cc0000",
  "Red/ White/ Heather Grey": "#cc0000",
  "Red/ White/ Navy": "#cc0000",
  "Red/ White/ Red": "#cc0000",
  "Red/Blk": "#cc0000",
  "Red/White": "#cc0000",
  "RedBlack": "#cc0000",
  "RedBrown": "#cc0000",
  "RedGold": "#cc0000",
  "RedHTH": "#c0303a",
  "RedHthr": "#c0303a",
  "RedOrange": "#ff4500",
  "RedOrangeHTH": "#ff4500",
  "RedPepperHTH": "#c0303a",
  "RedRockHTH": "#8b3a2f",
  "RedWoodHTH": "#8b3a2f",
  "Regal": "#4b0082",
  "RegalBlueHTH": "#1a3a6b",
  "Regatta Blue": "#1565c0",
  "Retro Heather Green": "#5a7a5a",
  "Retro Heather Navy": "#3a4a6b",
  "Retro Heather Red": "#c0303a",
  "Retro Heather Royal": "#3a5fa0",
  "RgttaBlue": "#2a5a9a",
  "Rich Green Grass": "#2e6b2e",
  "Rich Red": "#8b0000",
  "RichRed": "#8b0000",
  "Ripped Red": "#cc0000",
  "River Blue": "#4682b4",
  "River Blue Nvy": "#1e3a5f",
  "RiverBlNv": "#1e3a5f",
  "RiverBlue": "#4682b4",
  "RiverHTH": "#4682b4",
  "Robin Egg Blue": "#1fcecb",
  "RobinEggBlue": "#1fcecb",
  "Rock Grey": "#6b6b6b",
  "RockGrey": "#6b6b6b",
  "RockyHTH": "#6b6b6b",
  "Rose": "#ff007f",
  "Rose Dust": "#dcb0b0",
  "RoseGold": "#b76e79",
  "RoseGoldHTH": "#b76e79",
  "RosePink": "#ff007f",
  "RosePinkHTH": "#ff007f",
  "RoseQuartz": "#E8B0B8",
  "Rosewater Pink": "#ffc0cb",
  "Rosewood": "#a0423a",
  "RosewtrPk": "#E8A8B0",
  "RoyCaribe": "#1A60A0",
  "Royal": "#2e5ead",
  "Royal Blue": "#2e5ead",
  "Royal Caribe": "#2952a3",
  "Royal Frost": "#2952a3",
  "Royal Heather": "#3a5fa0",
  "Royal Pine": "#2952a3",
  "Royal/ Black": "#2952a3",
  "Royal/ Black/ Gold": "#2952a3",
  "Royal/ Black/ White": "#2952a3",
  "Royal/ Charcoal": "#2952a3",
  "Royal/ Charcoal/ Black Tri": "#2952a3",
  "Royal/ Gold": "#2952a3",
  "Royal/ Gold/ Black": "#2952a3",
  "Royal/ Gold/ White": "#2952a3",
  "Royal/ Grey": "#2952a3",
  "Royal/ Kelly": "#2952a3",
  "Royal/ Light Grey": "#2952a3",
  "Royal/ Orange": "#2952a3",
  "Royal/ Orange/ White": "#2952a3",
  "Royal/ Red": "#2952a3",
  "Royal/ Red/ White": "#2952a3",
  "Royal/ Silver": "#2952a3",
  "Royal/ Vegas Gold": "#2952a3",
  "Royal/ White": "#2952a3",
  "Royal/ White/ Gold": "#2952a3",
  "Royal/ White/ Heather Grey": "#2952a3",
  "Royal/ White/ Red": "#2952a3",
  "Royal/ White/ Royal": "#2952a3",
  "Royal/Black": "#2952a3",
  "Royal/Gold": "#2952a3",
  "Royal/White": "#2952a3",
  "RoyalBlHtr": "#3a5fa0",
  "RoyalBlue": "#2952a3",
  "RoyalFrost": "#3a5fa0",
  "RoyalGold": "#2952a3",
  "RoyalHTH": "#3a5fa0",
  "RoyalHthr": "#3a5fa0",
  "RoyalNavy": "#2952a3",
  "RoyalPine": "#1a4a2a",
  "RoyalPurple": "#4b0082",
  "RoyalTB": "#2952a3",
  "RoylPurple": "#4a2472",
  "Ruby Red": "#cc0000",
  "Russet": "#7b3a1a",
  "Rust": "#b7410e",
  "Rustic Orange": "#b05a2f",
  "Rustic Orange/ Khaki": "#ff6600",
  "RusticBrown": "#80461b",
  "RylGlassBl": "#3a6aaa",
  "S Orange": "#ff6600",
  "SAsphBlend": "#3a3a3a",
  "SGreen": "#2a7a3a",
  "SNaturalTb": "#f5f0e0",
  "SOrange": "#ff6600",
  "STrRyBlend": "#2e5ead",
  "Sable Duck Camo/ Black": "#4b5320",
  "Saddle": "#8b4513",
  "Safety Green": "#7fc241",
  "Safety Orange": "#ff6600",
  "Safety Yellow": "#e8f200",
  "Safety Ylw/Blk": "#F5E000",
  "SafetyGreen": "#39ff14",
  "SafetyOrange": "#ff6600",
  "SafetyYellow": "#ffff00",
  "Sage": "#8a9a7a",
  "Sage Green": "#b2ac88",
  "Sage/ White": "#b2ac88",
  "SageGreen": "#b2ac88",
  "SageHTH": "#8fac7a",
  "SageHthr": "#8fac7a",
  "Salmon": "#fa8072",
  "SalmonHTH": "#fa8072",
  "SalmonPink": "#fa8072",
  "Saltwater": "#3A8AA0",
  "Saltwater Duck Camo/ Charcoal": "#4b5320",
  "Saltwater Duck Camo/ Ice Grey": "#4b5320",
  "Sand": "#c8a96e",
  "Sand Dune/ Loden Green": "#C8B87A",
  "SandDune": "#c8a870",
  "SandHTH": "#c2b280",
  "SandStone": "#c8b89a",
  "Sandstone": "#c8a96e",
  "SandyBeach": "#c2b280",
  "Sangria": "#8b1a2a",
  "Sapphire": "#0e4c8a",
  "Sapphire Frost": "#5a8fa8",
  "SapphireBlue": "#0f52ba",
  "SapphireBlue/ Birch": "#0f52ba",
  "SapphireHTH": "#0f52ba",
  "SapphireHt": "#2A4A9A",
  "ScarRed": "#cc0000",
  "Scarlet": "#ff2400",
  "Scarlet Red": "#cc0000",
  "Scarlet/ Black": "#ff2400",
  "Scarlet/ Black/ White": "#ff2400",
  "Scarlet/ Gold": "#ff2400",
  "Scarlet/ Gold/ Black": "#ff2400",
  "Scarlet/ White": "#ff2400",
  "ScarletHTH": "#ff2400",
  "ScarletRed": "#ff2400",
  "ScarletWhite": "#ff2400",
  "SdKellyTb": "#228b22",
  "SdNvyBlend": "#1a2848",
  "SdOrangeTb": "#e8531a",
  "SdRedBlend": "#c0392b",
  "SdSilverTb": "#c0c0c0",
  "SdTmPrplTb": "#4a2472",
  "Sea Glass": "#a8c8b8",
  "Sea Green": "#2e6b2e",
  "Sea Green TB": "#3a8a6a",
  "SeaGlass": "#a8c8b8",
  "SeaGlassHTH": "#a8c8b8",
  "SeaGreen": "#2e8b57",
  "SeaMist": "#8AB8A8",
  "SeaPort": "#1a6b8a",
  "Seafoam": "#71eeb8",
  "Seafoam/ Natural": "#71eeb8",
  "SeafoamGreen": "#71eeb8",
  "SeafoamHTH": "#71eeb8",
  "SeagullHTH": "#c8d0d8",
  "Seaport": "#1a6b8a",
  "Sfty Orng/Blck": "#FF6000",
  "Sfty Ylw/Black": "#e8f200",
  "SftyGrn": "#7FC241",
  "SftyOrg": "#ff6600",
  "SftyYellow": "#e8f200",
  "Shadow": "#6A6A7A",
  "Shadow Grass Habitat/ Brown": "#8A9A6A",
  "Shadow Grey": "#7a7a7a",
  "Shiitake": "#8a7a6a",
  "Shiraz": "#7A1A3A",
  "Shock Blue": "#0047ab",
  "Shock Blue/Blk": "#1565c0",
  "ShockBlue": "#0047ab",
  "Sienna": "#a05a3a",
  "Sienna Duck Camo/ Loden Green": "#4b5320",
  "SierraBrown": "#8c6b4a",
  "Signal Red": "#cc0000",
  "Silver": "#c0c0c0",
  "Silver Grey": "#a8a8a8",
  "Silver/ Black": "#9e9e9e",
  "Silver/ Black-Silver": "#9e9e9e",
  "Silver/ Grey Camo": "#9e9e9e",
  "SilverBlue": "#a8b8c8",
  "SilverGrey": "#a8a8a8",
  "SilverHTH": "#c0c0c0",
  "SilverLakeHTH": "#a8b8c8",
  "SilverTan": "#9e9e9e",
  "Silverstone": "#9e9e9e",
  "Sky": "#87ceeb",
  "Sky Blue": "#87ceeb",
  "SkyBlue": "#87ceeb",
  "SkyBlue/ Navy": "#87ceeb",
  "SkyBlue/ White": "#87ceeb",
  "SkyHthr": "#90c8e8",
  "Slate": "#6a7a8a",
  "Slate Blue": "#6a7a9a",
  "Slate Green": "#2e6b2e",
  "Slate Grey": "#708090",
  "SlateBlue": "#6a7fa0",
  "SlateGrey": "#708090",
  "SlateHTH": "#6b7a8a",
  "SlateHthr": "#6b7a8a",
  "Sld Black TB": "#1c1c1c",
  "Sld Dk Grey TB": "#4a4a4a",
  "Sld Forest TB": "#2d5a1b",
  "Sld Maroon TB": "#7b1c2a",
  "Sld Navy TB": "#1a2848",
  "Sld Red TB": "#c0392b",
  "Sld White TB": "#f5f5f5",
  "SldAsphTb": "#3a3a3a",
  "SldAthGrey": "#b5b5b5",
  "SldBlueTb": "#2e5ead",
  "SldCarBlTb": "#6daedb",
  "SldSlateTb": "#6a7a8a",
  "SldTrRylTb": "#2e5ead",
  "SmkyAmthst": "#7A6A8A",
  "Smoke": "#8a8a8a",
  "Smoke Blue": "#1565c0",
  "Smoke Blue/ Aluminum": "#1565c0",
  "Smoke Blue/ Grey-White": "#1565c0",
  "Smoke Blue/ White": "#1565c0",
  "Smoke Grey": "#8a8a8a",
  "SmokeGrey": "#8a8a8a",
  "SmokeHTH": "#8a8a8a",
  "Smoked Paprika": "#A03828",
  "SmokeyGrey": "#8a8a8a",
  "SmokeyViolet": "#8b6b8b",
  "SmokyMaroon": "#7a1a2e",
  "Snow Camo": "#e8e8e0",
  "Snow Heather": "#e8e8e8",
  "SnowHTH": "#e8e8e8",
  "Soft Blue": "#add8e6",
  "Soft Blue/ Navy": "#1565c0",
  "Soft Coral": "#f08080",
  "Soft Cream": "#fdf6e3",
  "Soft Pink": "#f0c8d8",
  "Soft Purple": "#800080",
  "SoftCream": "#F8F0E0",
  "SoftGreenHTH": "#a8c8a8",
  "SoftGrey": "#d3d3d3",
  "SoftHTH": "#d3d3d3",
  "SoftLilac": "#c8a2c8",
  "SoftMint": "#98ff98",
  "SoftOrange": "#ffb347",
  "SoftOrangeHTH": "#ffb347",
  "SoftPink": "#ffb6c1",
  "SoftPinkHTH": "#ffb6c1",
  "SoftPurple": "#c8a2c8",
  "SoftPurpleHTH": "#c8a2c8",
  "SoftYellow": "#ffff99",
  "Sol Black Blnd": "#1c1c1c",
  "Sol White Blnd": "#f5f5f5",
  "Solid Charcoal": "#5c5c5c",
  "SolidBlack": "#111111",
  "SolidWhite": "#ffffff",
  "Soothing Blue": "#1565c0",
  "Spanish Moss": "#8A9A6A",
  "SpanishGold": "#c9941a",
  "Spark Silver": "#c0c0c0",
  "Spearmint": "#7AD4A8",
  "SpectraYlw": "#F8D800",
  "SpiceHTH": "#c8834a",
  "Sport Gray": "#9e9e9e",
  "Sport Grey": "#9e9e9e",
  "SportGrey": "#9e9e9e",
  "SportOrange": "#ff6600",
  "Sports Grey": "#9e9e9e",
  "SportsGrey": "#9e9e9e",
  "Spring Green": "#00ff7f",
  "SpringBlue": "#4682b4",
  "SpringGreen": "#00ff7f",
  "SpringHTH": "#90ee90",
  "SprngGrnTB": "#00ff7f",
  "Sprout": "#5a8a1a",
  "Spruce": "#2A5A3A",
  "Spruce/ Birch/ Light Navy": "#2A5A3A",
  "Stargazer": "#2A2A7A",
  "StarlightBlue": "#1a52c7",
  "Steel": "#8a9a9a",
  "Steel Blue": "#4a7a9a",
  "Steel Blue TB": "#4a7a9a",
  "Steel Blue/ Silver": "#1565c0",
  "Steel Grey": "#9e9e9e",
  "SteelBlue": "#4a7a9a",
  "SteelGrey": "#708090",
  "SteelHTH": "#708090",
  "StnwshDnm": "#5b7fa6",
  "StnwshdBl": "#5A7A9A",
  "Stone": "#928e85",
  "Stone Blue": "#1565c0",
  "Stone Grey": "#928e85",
  "Stone Heather": "#9e9e9e",
  "Stone/ Black": "#928e85",
  "Stone/ Light Olive/ White": "#9A9080",
  "StoneBlue": "#6a7a8a",
  "StoneGrey": "#928e85",
  "StoneHTH": "#928e85",
  "Stonewash Blue": "#1565c0",
  "Stonewash Denim": "#5A7A9A",
  "Stonewash Gree": "#5A7A5A",
  "Stonewash Green": "#2e6b2e",
  "Stonewashed Green": "#8fbc8f",
  "Storm": "#6a7a8a",
  "Storm Blue": "#4a6a8a",
  "Storm Grey": "#6b7a8a",
  "Storm TB": "#6a7a8a",
  "StormBlue": "#1a3a5c",
  "StormCloud": "#5A6A7A",
  "StormGrey": "#6b7a8a",
  "StormHTH": "#6b7a8a",
  "StormyHTH": "#6b7a8a",
  "Straw": "#e4d96f",
  "Strawberry": "#fc5a8d",
  "StrawberryHTH": "#fc5a8d",
  "Strong Blue": "#1565c0",
  "Summer Sky Blue": "#1565c0",
  "Summer Squash Yellow": "#F8C030",
  "SummerBlue": "#4682b4",
  "SummerGreen": "#5a8a1a",
  "SummerOrange": "#ff8c00",
  "SummerPink": "#f4a7b9",
  "Sunburst Yllw": "#F8D000",
  "Sunflower": "#f5c800",
  "Sunflower Yellow": "#f5c800",
  "Sunflower Yllw": "#F8C820",
  "SunflowerHTH": "#f5c800",
  "SunriseHTH": "#ff6b35",
  "Sunset": "#e86830",
  "Sunset Orange": "#ff6b35",
  "Sunset TB": "#e86830",
  "SunsetHTH": "#ff6b35",
  "SunsetOrange": "#ff6b35",
  "SwampGreen": "#4a6a3a",
  "Sweet Coral": "#f08080",
  "SweetBlue": "#6699cc",
  "SynthtcGrn": "#3a7a3a",
  "TNF Black Hthr": "#2a2a2a",
  "TNF Med Gry He": "#8A8A8A",
  "TRoyHthr": "#9e9e9e",
  "Tactical Green": "#2e6b2e",
  "TacticalGn": "#4A5A2A",
  "Tahiti Blue Sleeves/ Heather White Body": "#1565c0",
  "TahitiBlue": "#0090a0",
  "Tan": "#c8a060",
  "Tan Camo": "#4b5320",
  "Tan TB": "#c8a060",
  "Tan/ Brown": "#c3b091",
  "Tan/ Loden/ Brown": "#C8A870",
  "Tan/Brown": "#c3b091",
  "TanBrown": "#c3b091",
  "TanHTH": "#c3b091",
  "Tangerine": "#f28500",
  "Tanzanite": "#3A3A8A",
  "TarmacGrey": "#9e9e9e",
  "TarmacGyHt": "#5A5A5A",
  "Taupe": "#483c32",
  "Teal": "#008080",
  "Teal Green": "#006b5a",
  "Teal TB": "#008080",
  "Teal/ Black": "#008080",
  "Teal/ Navy": "#008080",
  "Teal/ Orange": "#008080",
  "Teal/ White": "#008080",
  "TealBlue": "#008080",
  "TealGreen": "#006b5a",
  "TealHTH": "#3d8a7a",
  "TealHthr": "#3d8a7a",
  "TealNavy": "#006b5a",
  "TealPurple": "#008080",
  "TealTB": "#008080",
  "Team Purple": "#4a2472",
  "TeamNavy": "#1a2848",
  "TeamPurple": "#4a2472",
  "TeamRed": "#cc0000",
  "TennOrange": "#ff6600",
  "Tennessee Orng": "#BF5700",
  "Terracota": "#A05030",
  "Terracotta": "#e2725b",
  "TerracottaHTH": "#e2725b",
  "Texas Orange": "#bf5700",
  "Texas Orange/ Khaki": "#ff6600",
  "Texas Orange/ White": "#ff6600",
  "Thyme": "#5a7a4a",
  "TidalBlue": "#1565c0",
  "TidalWave": "#1A6A9A",
  "Tie Dye Aqua Blue": "#1565c0",
  "Tie Dye Black": "#111111",
  "Tie Dye Cotton Candy": "#F8A0C8",
  "Tie Dye Navy": "#003366",
  "Tie Dye Olive": "#808000",
  "Tie Dye Pink": "#ffc0cb",
  "Tie Dye Sunset Swirl": "#E86030",
  "Tiger Camo": "#8a6a2a",
  "Titanium": "#878787",
  "Titanium Grey": "#878787",
  "TitaniumHTH": "#878787",
  "TlMonstera": "#2A6A2A",
  "TmbrGrnHtr": "#5A7A3A",
  "Toast": "#b08060",
  "Tobacco": "#6f4e37",
  "Topaz Blue": "#0088cc",
  "Topo/ Charcoal": "#5A5A5A",
  "TownsendGn": "#3A6A3A",
  "TrCeladon": "#8AB8A0",
  "TrNvyHthr": "#9e9e9e",
  "Trenchcoat/ Russet-Grey": "#9e9e9e",
  "Tropic Blue": "#1565c0",
  "Tropical Blue": "#1565c0",
  "Tropical Pink": "#ffc0cb",
  "TrplBlue": "#1a3a8a",
  "True Black": "#0a0a0a",
  "True Blue": "#0047ab",
  "True Navy": "#1a2848",
  "True Red": "#c0392b",
  "True Royal": "#2e5ead",
  "True Royl TB": "#2e5ead",
  "TrueBlue": "#0047ab",
  "TrueBlueHTH": "#0047ab",
  "TrueKllyGr": "#2E7D32",
  "TrueNavy": "#003087",
  "TrueNavyHTH": "#003087",
  "TrueRed": "#cc0000",
  "TrueRedHTH": "#cc0000",
  "TrueRoyal": "#2e5ead",
  "TrueRoyal/ Black": "#2952a3",
  "TrueRoyal/ White": "#2952a3",
  "TrueRoyalHTH": "#2952a3",
  "Tulip": "#f08080",
  "TundraBlu": "#3A6A8A",
  "TundraBrown": "#6b4c2a",
  "Turf Green": "#2a7a3a",
  "TurfGreen": "#2a7a3a",
  "Turquoise": "#30d5c8",
  "Turquoise Frst": "#40B0B8",
  "Turquoise/ White": "#40B0B8",
  "TurquoiseBlue": "#40e0d0",
  "TurquoiseHTH": "#40e0d0",
  "Twilight": "#1a3a6b",
  "Twilight Blue": "#1a3a6b",
  "TwilightBlue": "#1a3a6b",
  "TwilightHTH": "#1a3a6b",
  "Ultra Blue": "#0033a0",
  "UltraBlue": "#0033a0",
  "UltraViolet": "#7f00ff",
  "Ultramarine": "#1A1A9A",
  "Ultramrne Blue": "#1565c0",
  "Umber": "#635147",
  "UniRed": "#cc0000",
  "Urban Navy Hth": "#3a4a6b",
  "UrbanLilac": "#A090B8",
  "ValorBlue": "#1565c0",
  "VanillaYellow": "#f5e642",
  "VarMaize": "#F5C020",
  "Varsity Gold": "#c9941a",
  "Vegas Gold": "#c5b358",
  "Vegas Gold/ Black": "#c5b358",
  "Vegas Gold/ Black/ White": "#c5b358",
  "Vegas Gold/ Navy": "#c5b358",
  "Vegas Gold/ Royal": "#c5b358",
  "VegasGold": "#c5b358",
  "VegasGold/ Black": "#c5b358",
  "VegasGold/ White": "#c5b358",
  "Veil Wideland": "#8A9A7A",
  "Vineyard Vines Blue": "#1a5fa0",
  "Vintage Black": "#2c2c2c",
  "Vintage Black Sleeves/ Heather White Body": "#111111",
  "Vintage Black Sleeves/ Premium Heather Body": "#111111",
  "Vintage Black Sleeves/ Vintage Black Body": "#111111",
  "Vintage Brown": "#6b4c2a",
  "Vintage Navy": "#1a2a4a",
  "Vintage Navy Sleeves/ Premium Heather Body": "#003366",
  "Vintage Pink Sleeves/ Heather White Body": "#ffc0cb",
  "Vintage Purple Sleeves/ Heather White Body": "#800080",
  "Vintage Red Sleeves/ Heather White Body": "#cc0000",
  "Vintage Red Sleeves/ Premium Heather Body": "#cc0000",
  "Vintage Red Sleeves/ Vintage Black Body": "#cc0000",
  "Vintage Royal Sleeves/ Heather White Body": "#2952a3",
  "Vintage Royal Sleeves/ Premium Heather Body": "#2952a3",
  "Vintage Smoke": "#8a8a8a",
  "Vintage White": "#f5f0e8",
  "VintageBlack": "#2a2a2a",
  "VintageBrn": "#7a5040",
  "VintageNavy": "#1a2a4a",
  "Violet": "#6a2a9a",
  "VioletHTH": "#7f00ff",
  "VioletHaze": "#7a3a9b",
  "VioletHeather": "#7a3a9b",
  "VioletPurple": "#7a3a9b",
  "VioletTB": "#7f00ff",
  "VivaYellow": "#F5D800",
  "VivdTealHr": "#008080",
  "VividPink": "#ffc0cb",
  "VtgBlack": "#2c2c2c",
  "VtgDenim": "#5b7fa6",
  "VtgNavy": "#2a3a5a",
  "VtgRed": "#9b1b2a",
  "VtgWhite": "#f5f0e8",
  "Warm Grey": "#9e9e9e",
  "WarmBrownHTH": "#8c6b4a",
  "WarmGold": "#c9941a",
  "WarmGray": "#9a9080",
  "WarmGrey": "#9e9e9e",
  "WarmGreyHTH": "#9e9e9e",
  "WarmNavy": "#003366",
  "WarmRed": "#cc3333",
  "WarmTanHTH": "#c3b091",
  "Wasabi": "#8fbc8f",
  "WashDenim": "#5b7fa6",
  "Washed Banana Cream": "#F8F0D0",
  "Washed Black": "#111111",
  "Washed Cardinal": "#8b0000",
  "Washed Denim": "#5b7fa6",
  "Washed Graphite Black": "#111111",
  "Washed Mauve": "#C8A0B0",
  "Washed Military Green": "#2e6b2e",
  "Washed Natural": "#F0E8D0",
  "Washed Purple Rush": "#800080",
  "Washed Royal": "#2952a3",
  "Washed Royal Pine": "#2952a3",
  "Washed Stonewash Denim": "#5A7A9A",
  "Washed White": "#ffffff",
  "WashedDnm": "#5A7A9A",
  "WashedNavy": "#1a2a4a",
  "WashedSlate": "#6b7a8a",
  "WashedStone": "#928e85",
  "WashedTeal": "#3d8a7a",
  "Watermelon": "#fc6c85",
  "Wheat": "#D4B878",
  "White": "#f5f5f5",
  "White Frost": "#f0f4f8",
  "White Heather": "#e8e8e8",
  "White/ Aluminum/ Black": "#ffffff",
  "White/ Aluminum/ Navy": "#ffffff",
  "White/ Black": "#ffffff",
  "White/ Black CMB": "#ffffff",
  "White/ Black/ Gold": "#ffffff",
  "White/ Black/ Red": "#ffffff",
  "White/ Black/ Royal": "#ffffff",
  "White/ Blue Hawaiin/ Pale Orange": "#ffffff",
  "White/ Charcoal": "#ffffff",
  "White/ Charcoal CMB": "#ffffff",
  "White/ Charcoal/ Black": "#ffffff",
  "White/ Columbia Blue CMB": "#ffffff",
  "White/ Columbia Blue/ Yellow": "#ffffff",
  "White/ Forest": "#ffffff",
  "White/ Grey": "#ffffff",
  "White/ Kelly Green": "#ffffff",
  "White/ Kelly Green CMB": "#ffffff",
  "White/ Maroon": "#ffffff",
  "White/ Navy": "#ffffff",
  "White/ Navy CMB": "#ffffff",
  "White/ Navy/ Red": "#ffffff",
  "White/ Red": "#ffffff",
  "White/ Red CMB": "#ffffff",
  "White/ Red/ Black": "#ffffff",
  "White/ Royal": "#ffffff",
  "White/ Royal CMB": "#ffffff",
  "White/ Royal/ Gold": "#ffffff",
  "White/ Royal/ Red Tri": "#ffffff",
  "White/ Scarlet": "#ffffff",
  "White/ Vegas Gold": "#ffffff",
  "White/ White": "#ffffff",
  "White/ White-Black": "#ffffff",
  "White/Black": "#ffffff",
  "White/Blue": "#ffffff",
  "White/Red": "#ffffff",
  "WhiteHTH": "#f8f8f8",
  "WhiteSmoke": "#ffffff",
  "Wht Fleck TB": "#f0ede8",
  "WhtTB": "#ffffff",
  "Wild Berry": "#8b0057",
  "WildBerry": "#8b0057",
  "WildBlueYonder": "#a2add0",
  "WildBlueberry": "#4169e1",
  "WildFlower": "#c71585",
  "WildForest": "#1a3a1a",
  "WildGreen": "#5a8a1a",
  "WildKiwi": "#8ee53f",
  "WildRed": "#cc0000",
  "Williamsburg Blue": "#315f8c",
  "WindsorBlue": "#1a3a6b",
  "Wine": "#722f37",
  "WineHTH": "#7a1a2e",
  "WineHthr": "#7a1a2e",
  "WineRed": "#722f37",
  "WinterBlue": "#4682b4",
  "WinterGreen": "#2e5e2e",
  "WinterHTH": "#c8d0d8",
  "WinterWhite": "#f8f8f8",
  "Wisteria": "#9A80B8",
  "WisteriaHTH": "#c8a2c8",
  "Wood Violet": "#7a3a9b",
  "WoodGrain": "#8c6b4a",
  "Woodland Brown": "#6b4c2a",
  "WoodlandBr": "#5A4030",
  "WoodlandCamo": "#4b5320",
  "WorkerBlue": "#1565c0",
  "WstriaHthr": "#9e9e9e",
  "Yam": "#C06830",
  "Yellow": "#f5c518",
  "Yellow Gold": "#f5c800",
  "Yellow Haze": "#f5e642",
  "YellowGold": "#f5c800",
  "YellowHaze": "#f5e642",
  "YellowOrange": "#f5a500",
  "Yellw Gld TB": "#c9a227",
  "ZestOrange": "#e65100",
  "Zesty Orange": "#e65100",
  "Zinc": "#6b6b6b",
  "ZincHTH": "#6b6b6b",
  "Zinnia": "#e65100"
};